<template>
  <div>
    <b-modal
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      scrollable
      :title="
        (isEditWorkFlow
          ? 'Update '
          : isDuplicateWorkFlow
          ? 'Duplicate '
          : 'Add New ') + ' Employee Onboarding'
      "
      size="xl"
      :lazy="true"
      v-model="showAddModal"
    >
      <div>
        <div v-if="!submiting && !responseSuccess">
          <b-overlay
            :show="loadingEmployeeData"
            rounded="sm"
          >
            <b-tabs
              small
              card
              fill
            >
              <b-tab title="Setup">
                <b-row>
                  <b-col cols="6">
                    <b-form-group description="Please enter a title">
                      <label class="text-left">
                        Title:
                        <span class="required-span">*</span>
                      </label>
                      <b-form-input
                        size="sm"
                        type="text"
                        v-model.lazy="$v.form.title.$model"
                        :state="$v.form.title.$dirty ? !$v.form.title.$error : null"
                        @input="setTitleValue"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group description="Please enter a version">
                      <label class="text-left">
                        Version:
                        <span class="required-span">*</span>
                      </label>
                      <b-form-input
                        size="sm"
                        type="text"
                        v-model="$v.form.version.$model"
                        :state="$v.form.version.$dirty ? !$v.form.version.$error : null"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="mt-4">
                  <b-col
                    cols="6"
                    v-if="form.title"
                  >
                    <b-form-group>
                      <b-form-checkbox
                        inline
                        v-model="selectedLanguage"
                        v-for="(language, index) in languagesOptions"
                        :key="index"
                        :value="language"
                        :disabled="language.text == 'English' ? true : false"
                        @input="setNewLanguageEmail"
                      >{{ language.text }}</b-form-checkbox>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-tab>
              <!-- @click="loadingEmployeeData = true" -->
              <b-tab
                title="Configration"
                lazy
                v-if="form.title"
              >
                <b-tabs
                  small
                  card
                  fill
                >
                  <b-tab title="Proccess">
                    <b-card title="Create Different Workflow Proccesses">
                      <b-button
                        class="float-right"
                        size="sm"
                        variant="outline-info"
                        @click="addRowInTable"
                      >
                        <font-awesome-icon icon="plus" />
                      </b-button>
                      <b-table-simple class="table my-2">
                        <b-thead>
                          <b-tr>
                            <b-th scope="col">
                              Title
                              <span class="required-span">*</span>
                            </b-th>
                            <b-th scope="col">
                              Start From
                              <span class="required-span">*</span>
                            </b-th>
                            <b-th scope="col">
                              To Date
                              <span class="required-span">*</span>
                            </b-th>
                            <b-th scope="col">
                              <b-row>
                                <b-col
                                  cols="10"
                                  class="pr-0"
                                >
                                  Certification, Training Date
                                </b-col>
                                <b-col
                                  cols="2"
                                  class="pl-0"
                                >
                                  <span class="required-span">*</span>
                                </b-col>
                              </b-row>
                            </b-th>
                            <b-th scope="col">Action</b-th>
                          </b-tr>
                        </b-thead>

                        <b-tbody>
                          <b-tr
                            v-for="(cloenFields, cloenFieldsIndex) in configrationSettings"
                            :key="cloenFieldsIndex"
                          >
                            <b-td>
                              <b-form-group :invalid-feedback="invalidTitleValue">
                                <b-form-input
                                  @change="setTitleIndex($event, cloenFieldsIndex)"
                                  size="sm"
                                  :state="invalidTitleValue ? false : null"
                                  v-model="configrationSettings[cloenFieldsIndex].title"
                                ></b-form-input>
                              </b-form-group>
                            </b-td>
                            <b-td>
                              <b-form-group>
                                <b-input-group>
                                  <Datepicker
                                    wrapper-class="form-control-small-date-picker"
                                    input-class="workflow-setting-custom-date-picker"
                                    calendar-class="workflow-setting-date-calender"
                                    class="form-control"
                                    :format="formatDate"
                                    :class="invalidStartDateValue ? 'border border-danger rounded' : null"
                                    v-model="configrationSettings[cloenFieldsIndex].startDate"
                                    @input="setStartDateIndex($event, cloenFieldsIndex)"
                                  ></Datepicker>
                                  <b-input-group-append>
                                    <span class="input-group-text">
                                      <i class="fa fa-calendar"></i>
                                    </span>
                                  </b-input-group-append>
                                  <p
                                    v-if="invalidStartDateValue"
                                    class="text-feedback"
                                  >
                                    {{ invalidStartDateValue }}
                                  </p>
                                </b-input-group>
                              </b-form-group>
                            </b-td>
                            <b-td>
                              <b-form-group>
                                <b-input-group>
                                  <Datepicker
                                    wrapper-class="form-control-small-date-picker"
                                    input-class="workflow-setting-custom-date-picker"
                                    calendar-class="workflow-setting-date-calender"
                                    class="form-control"
                                    :format="formatDate"
                                    :class="invalidEndDateValue ? 'border border-danger rounded' : null"
                                    v-model="configrationSettings[cloenFieldsIndex].endDateValue"
                                    @input="setEndDateIndex($event, cloenFieldsIndex)"
                                  ></Datepicker>
                                  <!-- @closed="setSettingsLanuages(cloenFieldsIndex)" -->
                                  <b-input-group-append>
                                    <span class="input-group-text">
                                      <i class="fa fa-calendar"></i>
                                    </span>
                                  </b-input-group-append>
                                  <p
                                    v-if="invalidEndDateValue"
                                    class="text-feedback"
                                  >
                                    {{ invalidEndDateValue }}
                                  </p>
                                </b-input-group>
                              </b-form-group>
                            </b-td>
                            <b-td>
                              <b-form-group>
                                <b-input-group>
                                  <Datepicker
                                    wrapper-class="form-control-small-date-picker"
                                    input-class="workflow-setting-custom-date-picker"
                                    calendar-class="workflow-setting-date-calender"
                                    class="form-control"
                                    :format="formatDate"
                                    :class="invalidCertificationAndTrainingDateValue ? 'border border-danger rounded' : null"
                                    v-model="configrationSettings[cloenFieldsIndex].certificationAndTrainingDate"
                                    @input="setCertificationAndTrainingDateIndex($event, cloenFieldsIndex)"
                                    :use-utc="true"
                                  ></Datepicker>
                                  <b-input-group-append>
                                    <span class="input-group-text">
                                      <i class="fa fa-calendar"></i>
                                    </span>
                                  </b-input-group-append>
                                  <p
                                    v-if="invalidCertificationAndTrainingDateValue"
                                    class="text-feedback"
                                  >
                                    {{ invalidCertificationAndTrainingDateValue }}
                                  </p>
                                </b-input-group>
                              </b-form-group>
                            </b-td>
                            <b-td style="padding-top: 0px">
                              <b-button
                                variant="outline-danger"
                                v-if="cloenFieldsIndex > 0"
                                size="sm"
                                @click="onDeleteAmountRow(cloenFieldsIndex)"
                              >
                                <i class="fa fa-trash"></i>
                              </b-button>
                            </b-td>
                          </b-tr>
                        </b-tbody>
                      </b-table-simple>
                    </b-card>
                  </b-tab>
                  <b-tab
                    :title="configurTab.title"
                    v-for="(configurTab, configurTabIndex) in configrationSettings"
                    :key="configurTabIndex"
                  >
                    <!-- @click="setEmailLanguages(configurTabIndex)" -->
                    <b-card v-if="configurTab.endDateValue != null">
                      <b-tabs>
                        <b-tab title="Configration">
                          <b-form-group label="Email Tags:">
                            <multiselect
                              v-model.lazy="configrationSettings[configurTabIndex].configration.emailTags"
                              label="text"
                              track-by="value"
                              :options="emailTagsOptions"
                              :multiple="true"
                              :taggable="true"
                            ></multiselect>
                          </b-form-group>
                          <b-form-group
                            class="mt-3"
                            label="Platform Setting:"
                          >
                            <multiselect
                              v-model.lazy="configrationSettings[configurTabIndex].configration.platformSettings"
                              label="platform_variable_name"
                              track-by="platform_variable_value"
                              :options="platformSettingOptions"
                              :multiple="true"
                              :taggable="true"
                            ></multiselect>
                          </b-form-group>
                        </b-tab>
                        <b-tab title="Policy">
                          <b-tabs>
                            <b-tab title="Forms">
                              <b-form-group
                                label="Select Policy Onboarding Forms"
                                class="mt-4"
                              >
                                <b-form-checkbox
                                  inline
                                  v-model="configrationSettings[configurTabIndex].policyForms.forms"
                                  v-for="(forms, index) in policyFormsOptions"
                                  :key="index"
                                  :value="{value:forms.value, reletedFormIds:forms.reletedFormIds}"
                                >{{ forms.text }}</b-form-checkbox>
                              </b-form-group>
                            </b-tab>
                            <b-tab title="Email">
                              <b-card>
                                <b-tabs
                                  small
                                  nav-class="employee-languages-tabs-layout"
                                >
                                  <b-tab
                                    v-for="(emailLanguage, lanuageIndex) in selectedLanguage"
                                    :key="lanuageIndex"
                                    :title="emailLanguage.text"
                                  >
                                    <b-tabs
                                      justified
                                      vertical
                                      pills
                                      small
                                      fill
                                    >
                                      <b-tab title="Tasks Email">
                                        <label class="mt-3 mb-0">Tasks Email</label>
                                        <div class="my-2">
                                          <b-row>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(tags, tagsIndex) in configrationSettings[configurTabIndex].configration.emailTags"
                                                    :key="tagsIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge
                                                      variant="success"
                                                      style="cursor: pointer;"
                                                    >
                                                      <p @click="setTagValue('[['+tags.text+']]', configurTabIndex, emailLanguage.value, 'policyForms', 'tasksEmail')">{{ tags.text }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(platform, platformIndex) in configrationSettings[configurTabIndex].configration.platformSettings"
                                                    :key="platformIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge
                                                      variant="success"
                                                      style="cursor: pointer;"
                                                    >
                                                      <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configurTabIndex, emailLanguage.value, 'policyForms', 'tasksEmail')">{{ platform.platform_variable_name }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                          </b-row>
                                        </div>
                                        <b-form-group
                                          class="my-3"
                                          label="Email Subject"
                                        >
                                          <b-form-input
                                            v-model="configrationSettings[configurTabIndex].policyForms.emails[emailLanguage.value].tasksEmail.subject"
                                            size="sm"
                                          ></b-form-input>
                                        </b-form-group>
                                        <b-spinner
                                          v-if="policyFormsTasksEmail"
                                          label="Spinning"
                                        ></b-spinner>
                                        <b-form-group
                                          v-else
                                          label="Email Body"
                                        >
                                          <wysiwyg v-model="configrationSettings[configurTabIndex].policyForms.emails[emailLanguage.value].tasksEmail.message" />
                                        </b-form-group>
                                      </b-tab>
                                      <b-tab title="Tasks Reminder Email">
                                        <label class="mt-3 mb-0">Tasks Reminder Email</label>
                                        <div class="my-2">
                                          <b-row>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(tags, tagsIndex) in configrationSettings[configurTabIndex].configration.emailTags"
                                                    :key="tagsIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge variant="success">
                                                      <p @click="setTagValue('[['+tags.text+']]', configurTabIndex, emailLanguage.value, 'policyForms', 'taskReminderEmail')">{{ tags.text }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(platform, platformIndex) in configrationSettings[configurTabIndex].configration.platformSettings"
                                                    :key="platformIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge
                                                      variant="success"
                                                      style="cursor: pointer;"
                                                    >
                                                      <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configurTabIndex, emailLanguage.value, 'policyForms', 'taskReminderEmail')">{{ platform.platform_variable_name }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                          </b-row>
                                        </div>
                                        <b-form-group
                                          class="my-3"
                                          label="Email Subject"
                                        >
                                          <b-form-input
                                            v-model="configrationSettings[configurTabIndex].policyForms.emails[emailLanguage.value].taskReminderEmail.subject"
                                            size="sm"
                                          ></b-form-input>
                                        </b-form-group>
                                        <b-spinner
                                          v-if="policyFormsTasksReminderEmail"
                                          label="Spinning"
                                        ></b-spinner>
                                        <b-form-group
                                          v-else
                                          label="Email Body"
                                        >
                                          <wysiwyg v-model="configrationSettings[configurTabIndex].policyForms.emails[emailLanguage.value].taskReminderEmail.message" />
                                        </b-form-group>
                                      </b-tab>
                                      <b-tab title="Tasks Completion Email">
                                        <label class="mt-3 mb-0">Tasks Completion Email</label>
                                        <div class="my-2">
                                          <b-row>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(tags, tagsIndex) in configrationSettings[configurTabIndex].configration.emailTags"
                                                    :key="tagsIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge variant="success">
                                                      <p @click="setTagValue('[['+tags.text+']]', configurTabIndex, emailLanguage.value, 'policyForms', 'taskCompletionEmail')">{{ tags.text }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(platform, platformIndex) in configrationSettings[configurTabIndex].configration.platformSettings"
                                                    :key="platformIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge
                                                      variant="success"
                                                      style="cursor: pointer;"
                                                    >
                                                      <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configurTabIndex, emailLanguage.value, 'policyForms', 'taskCompletionEmail')">{{ platform.platform_variable_name }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                          </b-row>
                                        </div>
                                        <b-form-group
                                          class="my-3"
                                          label="Email Subject"
                                        >
                                          <b-form-input
                                            v-model="configrationSettings[configurTabIndex].policyForms.emails[emailLanguage.value].taskCompletionEmail.subject"
                                            size="sm"
                                          ></b-form-input>
                                        </b-form-group>
                                        <b-spinner
                                          v-if="policyFormsTasksCompletionEmail"
                                          label="Spinning"
                                        ></b-spinner>
                                        <b-form-group
                                          v-else
                                          label="Email Body"
                                        >
                                          <wysiwyg v-model="configrationSettings[configurTabIndex].policyForms.emails[emailLanguage.value].taskCompletionEmail.message" />
                                        </b-form-group>
                                      </b-tab>
                                      <b-tab title="Renew Tasks Email">
                                        <label class="mt-3 mb-0">Renew Tasks Email</label>
                                        <div class="my-2">
                                          <b-row>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(tags, tagsIndex) in configrationSettings[configurTabIndex].configration.emailTags"
                                                    :key="tagsIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge variant="success">
                                                      <p @click="setTagValue('[['+tags.text+']]', configurTabIndex, emailLanguage.value, 'policyForms', 'renewTasksEmail')">{{ tags.text }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(platform, platformIndex) in configrationSettings[configurTabIndex].configration.platformSettings"
                                                    :key="platformIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge
                                                      variant="success"
                                                      style="cursor: pointer;"
                                                    >
                                                      <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configurTabIndex, emailLanguage.value, 'policyForms', 'renewTasksEmail')">{{ platform.platform_variable_name }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                          </b-row>
                                        </div>
                                        <b-form-group
                                          class="my-3"
                                          label="Email Subject"
                                        >
                                          <b-form-input
                                            v-model="configrationSettings[configurTabIndex].policyForms.emails[emailLanguage.value].renewTasksEmail.subject"
                                            size="sm"
                                          ></b-form-input>
                                        </b-form-group>
                                        <b-spinner
                                          v-if="policyFormsRenewTasksEmail"
                                          label="Spinning"
                                        ></b-spinner>
                                        <b-form-group
                                          v-else
                                          label="Email Body"
                                        >
                                          <wysiwyg v-model="configrationSettings[configurTabIndex].policyForms.emails[emailLanguage.value].renewTasksEmail.message" />
                                        </b-form-group>
                                      </b-tab>
                                      <b-tab
                                        title="Additional Tasks Email"
                                        v-if="isShowAdditionlTaskEmail"
                                      >
                                        <label class="mt-3 mb-0">Additional Tasks Email</label>
                                        <div class="my-2">
                                          <b-row>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(tags, tagsIndex) in configrationSettings[configurTabIndex].configration.emailTags"
                                                    :key="tagsIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge variant="success">
                                                      <p @click="setTagValue('[['+tags.text+']]', configurTabIndex, emailLanguage.value, 'policyForms', 'additionalTasksEmail')">{{ tags.text }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(platform, platformIndex) in configrationSettings[configurTabIndex].configration.platformSettings"
                                                    :key="platformIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge
                                                      variant="success"
                                                      style="cursor: pointer;"
                                                    >
                                                      <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configurTabIndex, emailLanguage.value, 'policyForms', 'additionalTasksEmail')">{{ platform.platform_variable_name }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                          </b-row>
                                        </div>
                                        <b-form-group
                                          class="my-3"
                                          label="Email Subject"
                                        >
                                          <b-form-input
                                            v-model="configrationSettings[configurTabIndex].policyForms.emails[emailLanguage.value].additionalTasksEmail.subject"
                                            size="sm"
                                          ></b-form-input>
                                        </b-form-group>
                                        <b-spinner
                                          v-if="policyFormsAdditionalTasksEmail"
                                          label="Spinning"
                                        ></b-spinner>
                                        <b-form-group
                                          v-else
                                          label="Email Body"
                                        >
                                          <wysiwyg v-model="configrationSettings[configurTabIndex].policyForms.emails[emailLanguage.value].additionalTasksEmail.message" />
                                        </b-form-group>
                                      </b-tab>
                                    </b-tabs>
                                  </b-tab>
                                </b-tabs>
                              </b-card>
                            </b-tab>
                          </b-tabs>
                        </b-tab>
                        <b-tab title="Training">
                          <b-tabs>
                            <b-tab title="Forms">
                              <b-form-group
                                label="Select Training Forms"
                                class="mt-4"
                              >
                                <b-form-checkbox
                                  inline
                                  v-model="configrationSettings[configurTabIndex].trainingForms.forms"
                                  v-for="(forms, index) in trainingFormsOptions"
                                  :key="index"
                                  :value="{value:forms.value, reletedFormIds:forms.reletedFormIds}"
                                >{{ forms.text }}</b-form-checkbox>
                              </b-form-group>
                            </b-tab>
                            <b-tab title="Email">
                              <b-card>
                                <b-tabs
                                  small
                                  nav-class="employee-languages-tabs-layout"
                                >
                                  <b-tab
                                    v-for="(emailLanguage, lanuageIndex) in selectedLanguage"
                                    :key="lanuageIndex"
                                    :title="emailLanguage.text"
                                  >
                                    <b-tabs
                                      justified
                                      vertical
                                      pills
                                      small
                                      fill
                                    >
                                      <b-tab title="Tasks Email">
                                        <label class="mt-3 mb-0">Tasks Email</label>
                                        <div class="my-2">
                                          <b-row>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(tags, tagsIndex) in configrationSettings[configurTabIndex].configration.emailTags"
                                                    :key="tagsIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge variant="success">
                                                      <p @click="setTagValue('[['+tags.text+']]', configurTabIndex, emailLanguage.value, 'trainingForms', 'tasksEmail')">{{ tags.text }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(platform, platformIndex) in configrationSettings[configurTabIndex].configration.platformSettings"
                                                    :key="platformIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge
                                                      variant="success"
                                                      style="cursor: pointer;"
                                                    >
                                                      <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configurTabIndex, emailLanguage.value, 'trainingForms', 'tasksEmail')">{{ platform.platform_variable_name }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                          </b-row>
                                        </div>
                                        <b-form-group
                                          class="my-3"
                                          label="Email Subject"
                                        >
                                          <b-form-input
                                            v-model="configrationSettings[configurTabIndex].trainingForms.emails[emailLanguage.value].tasksEmail.subject"
                                            size="sm"
                                          ></b-form-input>
                                        </b-form-group>
                                        <b-spinner
                                          v-if="trainingFormsTasksEmail"
                                          label="Spinning"
                                        ></b-spinner>
                                        <b-form-group
                                          v-else
                                          label="Email Body"
                                        >
                                          <wysiwyg v-model="configrationSettings[configurTabIndex].trainingForms.emails[emailLanguage.value].tasksEmail.message" />
                                        </b-form-group>
                                      </b-tab>
                                      <b-tab title="Tasks Reminder Email">
                                        <label class="mt-3 mb-0">Tasks Reminder Email</label>
                                        <div class="my-2">
                                          <b-row>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(tags, tagsIndex) in configrationSettings[configurTabIndex].configration.emailTags"
                                                    :key="tagsIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge variant="success">
                                                      <p @click="setTagValue('[['+tags.text+']]', configurTabIndex, emailLanguage.value, 'trainingForms', 'taskReminderEmail')">{{ tags.text }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(platform, platformIndex) in configrationSettings[configurTabIndex].configration.platformSettings"
                                                    :key="platformIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge
                                                      variant="success"
                                                      style="cursor: pointer;"
                                                    >
                                                      <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configurTabIndex, emailLanguage.value, 'trainingForms', 'taskReminderEmail')">{{ platform.platform_variable_name }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                          </b-row>
                                        </div>
                                        <b-form-group
                                          class="my-3"
                                          label="Email Subject"
                                        >
                                          <b-form-input
                                            v-model="configrationSettings[configurTabIndex].trainingForms.emails[emailLanguage.value].taskReminderEmail.subject"
                                            size="sm"
                                          ></b-form-input>
                                        </b-form-group>
                                        <b-spinner
                                          v-if="trainingFormsTasksReminderEmail"
                                          label="Spinning"
                                        ></b-spinner>
                                        <b-form-group
                                          v-else
                                          label="Email Body"
                                        >
                                          <wysiwyg v-model="configrationSettings[configurTabIndex].trainingForms.emails[emailLanguage.value].taskReminderEmail.message" />
                                        </b-form-group>
                                      </b-tab>
                                      <b-tab title="Tasks Completion Email">
                                        <label class="mt-3 mb-0">Tasks Completion Email</label>
                                        <div class="my-2">
                                          <b-row>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(tags, tagsIndex) in configrationSettings[configurTabIndex].configration.emailTags"
                                                    :key="tagsIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge variant="success">
                                                      <p @click="setTagValue('[['+tags.text+']]', configurTabIndex, emailLanguage.value, 'trainingForms', 'taskCompletionEmail')">{{ tags.text }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(platform, platformIndex) in configrationSettings[configurTabIndex].configration.platformSettings"
                                                    :key="platformIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge
                                                      variant="success"
                                                      style="cursor: pointer;"
                                                    >
                                                      <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configurTabIndex, emailLanguage.value, 'trainingForms', 'taskCompletionEmail')">{{ platform.platform_variable_name }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                          </b-row>
                                        </div>
                                        <b-form-group
                                          class="my-3"
                                          label="Email Subject"
                                        >
                                          <b-form-input
                                            v-model="configrationSettings[configurTabIndex].trainingForms.emails[emailLanguage.value].taskCompletionEmail.subject"
                                            size="sm"
                                          ></b-form-input>
                                        </b-form-group>
                                        <b-spinner
                                          v-if="trainingFormsTasksCompletionEmail"
                                          label="Spinning"
                                        ></b-spinner>
                                        <b-form-group
                                          v-else
                                          label="Email Body"
                                        >
                                          <wysiwyg v-model="configrationSettings[configurTabIndex].trainingForms.emails[emailLanguage.value].taskCompletionEmail.message" />
                                        </b-form-group>
                                      </b-tab>
                                      <b-tab title="Renew Tasks Email">
                                        <label class="mt-3 mb-0">Renew Tasks Email</label>
                                        <div class="my-2">
                                          <b-row>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(tags, tagsIndex) in configrationSettings[configurTabIndex].configration.emailTags"
                                                    :key="tagsIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge variant="success">
                                                      <p @click="setTagValue('[['+tags.text+']]', configurTabIndex, emailLanguage.value, 'trainingForms', 'renewTasksEmail')">{{ tags.text }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(platform, platformIndex) in configrationSettings[configurTabIndex].configration.platformSettings"
                                                    :key="platformIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge
                                                      variant="success"
                                                      style="cursor: pointer;"
                                                    >
                                                      <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configurTabIndex, emailLanguage.value, 'trainingForms', 'renewTasksEmail')">{{ platform.platform_variable_name }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                          </b-row>
                                        </div>
                                        <b-form-group
                                          class="my-3"
                                          label="Email Subject"
                                        >
                                          <b-form-input
                                            v-model="configrationSettings[configurTabIndex].trainingForms.emails[emailLanguage.value].renewTasksEmail.subject"
                                            size="sm"
                                          ></b-form-input>
                                        </b-form-group>
                                        <b-spinner
                                          v-if="trainingFormsRenewTasksEmail"
                                          label="Spinning"
                                        ></b-spinner>
                                        <b-form-group
                                          v-else
                                          label="Email Body"
                                        >
                                          <wysiwyg v-model="configrationSettings[configurTabIndex].trainingForms.emails[emailLanguage.value].renewTasksEmail.message" />
                                        </b-form-group>
                                      </b-tab>
                                      <b-tab
                                        title="Additional Tasks Email"
                                        v-if="isShowAdditionlTaskEmail"
                                      >
                                        <label class="mt-3 mb-0">Additional Tasks Email</label>
                                        <div class="my-2">
                                          <b-row>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(tags, tagsIndex) in configrationSettings[configurTabIndex].configration.emailTags"
                                                    :key="tagsIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge variant="success">
                                                      <p @click="setTagValue('[['+tags.text+']]', configurTabIndex, emailLanguage.value, 'trainingForms', 'additionalTasksEmail')">{{ tags.text }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(platform, platformIndex) in configrationSettings[configurTabIndex].configration.platformSettings"
                                                    :key="platformIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge
                                                      variant="success"
                                                      style="cursor: pointer;"
                                                    >
                                                      <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configurTabIndex, emailLanguage.value, 'trainingForms', 'additionalTasksEmail')">{{ platform.platform_variable_name }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                          </b-row>
                                        </div>
                                        <b-form-group
                                          class="my-3"
                                          label="Email Subject"
                                        >
                                          <b-form-input
                                            v-model="configrationSettings[configurTabIndex].trainingForms.emails[emailLanguage.value].additionalTasksEmail.subject"
                                            size="sm"
                                          ></b-form-input>
                                        </b-form-group>
                                        <b-spinner
                                          v-if="trainingFormsAdditionalTasksEmail"
                                          label="Spinning"
                                        ></b-spinner>
                                        <b-form-group
                                          v-else
                                          label="Email Body"
                                        >
                                          <wysiwyg v-model="configrationSettings[configurTabIndex].trainingForms.emails[emailLanguage.value].additionalTasksEmail.message" />
                                        </b-form-group>
                                      </b-tab>
                                    </b-tabs>
                                  </b-tab>
                                </b-tabs>
                              </b-card>
                            </b-tab>
                          </b-tabs>
                        </b-tab>
                        <b-tab title="Certification">
                          <b-tabs>
                            <b-tab title="Forms">
                              <b-form-group
                                label="Select Certification Forms"
                                class="mt-4"
                              >
                                <b-form-checkbox
                                  inline
                                  v-model="configrationSettings[configurTabIndex].certificationForms.forms"
                                  v-for="(forms, index) in certificationFormsOptions"
                                  :key="index"
                                  :value="{value:forms.value, reletedFormIds:forms.reletedFormIds}"
                                >{{ forms.text }}</b-form-checkbox>
                              </b-form-group>
                            </b-tab>
                            <b-tab title="Email">
                              <b-card>
                                <b-tabs
                                  small
                                  nav-class="employee-languages-tabs-layout"
                                >
                                  <b-tab
                                    v-for="(emailLanguage, lanuageIndex) in selectedLanguage"
                                    :key="lanuageIndex"
                                    :title="emailLanguage.text"
                                  >
                                    <b-tabs
                                      justified
                                      vertical
                                      pills
                                      small
                                      fill
                                    >
                                      <b-tab title="Tasks Email">
                                        <label class="mt-3 mb-0">Tasks Email</label>
                                        <div class="my-2">
                                          <b-row>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(tags, tagsIndex) in configrationSettings[configurTabIndex].configration.emailTags"
                                                    :key="tagsIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge variant="success">
                                                      <p @click="setTagValue('[['+tags.text+']]', configurTabIndex, emailLanguage.value, 'certificationForms', 'tasksEmail')">{{ tags.text }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(platform, platformIndex) in configrationSettings[configurTabIndex].configration.platformSettings"
                                                    :key="platformIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge
                                                      variant="success"
                                                      style="cursor: pointer;"
                                                    >
                                                      <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configurTabIndex, emailLanguage.value, 'certificationForms', 'tasksEmail')">{{ platform.platform_variable_name }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                          </b-row>
                                        </div>
                                        <b-form-group
                                          class="my-3"
                                          label="Email Subject"
                                        >
                                          <b-form-input
                                            v-model="configrationSettings[configurTabIndex].certificationForms.emails[emailLanguage.value].tasksEmail.subject"
                                            size="sm"
                                          ></b-form-input>
                                        </b-form-group>
                                        <b-spinner
                                          v-if="certificationFormsTasksEmail"
                                          label="Spinning"
                                        ></b-spinner>
                                        <b-form-group
                                          v-else
                                          label="Email Body"
                                        >
                                          <wysiwyg v-model="configrationSettings[configurTabIndex].certificationForms.emails[emailLanguage.value].tasksEmail.message" />
                                        </b-form-group>
                                      </b-tab>
                                      <b-tab title="Tasks Reminder Email">
                                        <label class="mt-3 mb-0">Tasks Reminder Email</label>
                                        <div class="my-2">
                                          <b-row>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(tags, tagsIndex) in configrationSettings[configurTabIndex].configration.emailTags"
                                                    :key="tagsIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge variant="success">
                                                      <p @click="setTagValue('[['+tags.text+']]', configurTabIndex, emailLanguage.value, 'certificationForms', 'taskReminderEmail')">{{ tags.text }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(platform, platformIndex) in configrationSettings[configurTabIndex].configration.platformSettings"
                                                    :key="platformIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge
                                                      variant="success"
                                                      style="cursor: pointer;"
                                                    >
                                                      <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configurTabIndex, emailLanguage.value, 'certificationForms', 'taskReminderEmail')">{{ platform.platform_variable_name }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                          </b-row>
                                        </div>
                                        <b-form-group
                                          class="my-3"
                                          label="Email Subject"
                                        >
                                          <b-form-input
                                            v-model="configrationSettings[configurTabIndex].certificationForms.emails[emailLanguage.value].taskReminderEmail.subject"
                                            size="sm"
                                          ></b-form-input>
                                        </b-form-group>
                                        <b-spinner
                                          v-if="certificationFormsTasksReminderEmail"
                                          label="Spinning"
                                        ></b-spinner>
                                        <b-form-group
                                          v-else
                                          label="Email Body"
                                        >
                                          <wysiwyg v-model="configrationSettings[configurTabIndex].certificationForms.emails[emailLanguage.value].taskReminderEmail.message" />
                                        </b-form-group>
                                      </b-tab>
                                      <b-tab title="Tasks Completion Email">
                                        <label class="mt-3 mb-0">Tasks Completion Email</label>
                                        <div class="my-2">
                                          <b-row>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(tags, tagsIndex) in configrationSettings[configurTabIndex].configration.emailTags"
                                                    :key="tagsIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge variant="success">
                                                      <p @click="setTagValue('[['+tags.text+']]', configurTabIndex, emailLanguage.value, 'certificationForms', 'taskCompletionEmail')">{{ tags.text }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(platform, platformIndex) in configrationSettings[configurTabIndex].configration.platformSettings"
                                                    :key="platformIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge
                                                      variant="success"
                                                      style="cursor: pointer;"
                                                    >
                                                      <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configurTabIndex, emailLanguage.value, 'certificationForms', 'taskCompletionEmail')">{{ platform.platform_variable_name }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                          </b-row>
                                        </div>
                                        <b-form-group
                                          class="my-3"
                                          label="Email Subject"
                                        >
                                          <b-form-input
                                            v-model="configrationSettings[configurTabIndex].certificationForms.emails[emailLanguage.value].taskCompletionEmail.subject"
                                            size="sm"
                                          ></b-form-input>
                                        </b-form-group>
                                        <b-spinner
                                          v-if="certificationFormsTasksCompletionEmail"
                                          label="Spinning"
                                        ></b-spinner>
                                        <b-form-group
                                          v-else
                                          label="Email Body"
                                        >
                                          <wysiwyg v-model="configrationSettings[configurTabIndex].certificationForms.emails[emailLanguage.value].taskCompletionEmail.message" />
                                        </b-form-group>
                                      </b-tab>
                                      <b-tab title="Renew Tasks Email">
                                        <label class="mt-3 mb-0">Renew Tasks Email</label>
                                        <div class="my-2">
                                          <b-row>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(tags, tagsIndex) in configrationSettings[configurTabIndex].configration.emailTags"
                                                    :key="tagsIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge variant="success">
                                                      <p @click="setTagValue('[['+tags.text+']]', configurTabIndex, emailLanguage.value, 'certificationForms', 'renewTasksEmail')">{{ tags.text }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(platform, platformIndex) in configrationSettings[configurTabIndex].configration.platformSettings"
                                                    :key="platformIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge
                                                      variant="success"
                                                      style="cursor: pointer;"
                                                    >
                                                      <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configurTabIndex, emailLanguage.value, 'certificationForms', 'renewTasksEmail')">{{ platform.platform_variable_name }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                          </b-row>
                                        </div>
                                        <b-form-group
                                          class="my-3"
                                          label="Email Subject"
                                        >
                                          <b-form-input
                                            v-model="configrationSettings[configurTabIndex].certificationForms.emails[emailLanguage.value].renewTasksEmail.subject"
                                            size="sm"
                                          ></b-form-input>
                                        </b-form-group>
                                        <b-spinner
                                          v-if="certificationFormsRenewTasksEmail"
                                          label="Spinning"
                                        ></b-spinner>
                                        <b-form-group
                                          v-else
                                          label="Email Body"
                                        >
                                          <wysiwyg v-model="configrationSettings[configurTabIndex].certificationForms.emails[emailLanguage.value].renewTasksEmail.message" />
                                        </b-form-group>
                                      </b-tab>
                                      <b-tab title="Tasks Breach Email">
                                        <label class="mt-3 mb-0">Tasks Breach Email</label>
                                        <div class="my-2">
                                          <b-row>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(tags, tagsIndex) in configrationSettings[configurTabIndex].configration.emailTags"
                                                    :key="tagsIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge variant="success">
                                                      <p @click="setTagValue('[['+tags.text+']]', configurTabIndex, emailLanguage.value, 'certificationForms', 'tasksBreachEmail')">{{ tags.text }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(platform, platformIndex) in configrationSettings[configurTabIndex].configration.platformSettings"
                                                    :key="platformIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge
                                                      variant="success"
                                                      style="cursor: pointer;"
                                                    >
                                                      <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configurTabIndex, emailLanguage.value, 'certificationForms', 'tasksBreachEmail')">{{ platform.platform_variable_name }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                          </b-row>
                                        </div>
                                        <b-form-group
                                          class="my-3"
                                          label="Email Subject"
                                        >
                                          <b-form-input
                                            v-model="configrationSettings[configurTabIndex].certificationForms.emails[emailLanguage.value].tasksBreachEmail.subject"
                                            size="sm"
                                          ></b-form-input>
                                        </b-form-group>
                                        <b-spinner
                                          v-if="certificationFormsTasksBreachEmail"
                                          label="Spinning"
                                        ></b-spinner>
                                        <b-form-group
                                          v-else
                                          label="Email Body"
                                        >
                                          <wysiwyg v-model="configrationSettings[configurTabIndex].certificationForms.emails[emailLanguage.value].tasksBreachEmail.message" />
                                        </b-form-group>
                                      </b-tab>
                                      <b-tab
                                        title="Additional Tasks Email"
                                        v-if="isShowAdditionlTaskEmail"
                                      >
                                        <label class="mt-3 mb-0">Additional Tasks Email</label>
                                        <div class="my-2">
                                          <b-row>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(tags, tagsIndex) in configrationSettings[configurTabIndex].configration.emailTags"
                                                    :key="tagsIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge variant="success">
                                                      <p @click="setTagValue('[['+tags.text+']]', configurTabIndex, emailLanguage.value, 'certificationForms', 'additionalTasksEmail')">{{ tags.text }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(platform, platformIndex) in configrationSettings[configurTabIndex].configration.platformSettings"
                                                    :key="platformIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge
                                                      variant="success"
                                                      style="cursor: pointer;"
                                                    >
                                                      <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configurTabIndex, emailLanguage.value, 'certificationForms', 'additionalTasksEmail')">{{ platform.platform_variable_name }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                          </b-row>
                                        </div>
                                        <b-form-group
                                          class="my-3"
                                          label="Email Subject"
                                        >
                                          <b-form-input
                                            v-model="configrationSettings[configurTabIndex].certificationForms.emails[emailLanguage.value].additionalTasksEmail.subject"
                                            size="sm"
                                          ></b-form-input>
                                        </b-form-group>
                                        <b-spinner
                                          v-if="certificationFormsAdditionalTasksEmail"
                                          label="Spinning"
                                        ></b-spinner>
                                        <b-form-group
                                          v-else
                                          label="Email Body"
                                        >
                                          <wysiwyg v-model="configrationSettings[configurTabIndex].certificationForms.emails[emailLanguage.value].additionalTasksEmail.message" />
                                        </b-form-group>
                                      </b-tab>
                                    </b-tabs>
                                  </b-tab>
                                </b-tabs>
                              </b-card>
                            </b-tab>
                          </b-tabs>
                        </b-tab>
                        <b-tab
                          title-item-class="fit-width"
                          title="Health & safety Policy"
                        >
                          <b-tabs>
                            <b-tab title="Forms">
                              <b-form-group
                                label="Select Health & safety Policy Forms"
                                class="mt-4"
                              >
                                <b-form-checkbox
                                  inline
                                  v-model="configrationSettings[configurTabIndex].healthAndSaftyPolicy.forms"
                                  v-for="(forms, index) in healthAndSaftyPolicyFormsOptions"
                                  :key="index"
                                  :value="{value:forms.value, reletedFormIds:forms.reletedFormIds}"
                                >{{ forms.text }}</b-form-checkbox>
                              </b-form-group>
                            </b-tab>
                            <b-tab title="Email">
                              <b-card>
                                <b-tabs
                                  small
                                  nav-class="employee-languages-tabs-layout"
                                >
                                  <b-tab
                                    v-for="(emailLanguage, lanuageIndex) in selectedLanguage"
                                    :key="lanuageIndex"
                                    :title="emailLanguage.text"
                                  >
                                    <b-tabs
                                      justified
                                      vertical
                                      pills
                                      small
                                      fill
                                    >
                                      <b-tab title="Tasks Email">
                                        <label class="mt-3 mb-0">Tasks Email</label>
                                        <div class="my-2">
                                          <b-row>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(tags, tagsIndex) in configrationSettings[configurTabIndex].configration.emailTags"
                                                    :key="tagsIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge
                                                      variant="success"
                                                      style="cursor: pointer;"
                                                    >
                                                      <p @click="setTagValue('[['+tags.text+']]', configurTabIndex, emailLanguage.value, 'healthAndSaftyPolicyForms', 'tasksEmail')">{{ tags.text }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(platform, platformIndex) in configrationSettings[configurTabIndex].configration.platformSettings"
                                                    :key="platformIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge
                                                      variant="success"
                                                      style="cursor: pointer;"
                                                    >
                                                      <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configurTabIndex, emailLanguage.value, 'healthAndSaftyPolicyForms', 'tasksEmail')">{{ platform.platform_variable_name }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                          </b-row>
                                        </div>
                                        <b-form-group
                                          class="my-3"
                                          label="Email Subject"
                                        >
                                          <b-form-input
                                            v-model="configrationSettings[configurTabIndex].healthAndSaftyPolicy.emails[emailLanguage.value].tasksEmail.subject"
                                            size="sm"
                                          ></b-form-input>
                                        </b-form-group>
                                        <b-spinner
                                          v-if="healthAndSaftyPolicyFormsTasksEmail"
                                          label="Spinning"
                                        ></b-spinner>
                                        <b-form-group
                                          v-else
                                          label="Email Body"
                                        >
                                          <wysiwyg v-model="configrationSettings[configurTabIndex].healthAndSaftyPolicy.emails[emailLanguage.value].tasksEmail.message" />
                                        </b-form-group>
                                      </b-tab>
                                      <b-tab title="Tasks Reminder Email">
                                        <label class="mt-3 mb-0">Tasks Reminder Email</label>
                                        <div class="my-2">
                                          <b-row>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(tags, tagsIndex) in configrationSettings[configurTabIndex].configration.emailTags"
                                                    :key="tagsIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge variant="success">
                                                      <p @click="setTagValue('[['+tags.text+']]', configurTabIndex, emailLanguage.value, 'healthAndSaftyPolicyForms', 'taskReminderEmail')">{{ tags.text }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(platform, platformIndex) in configrationSettings[configurTabIndex].configration.platformSettings"
                                                    :key="platformIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge
                                                      variant="success"
                                                      style="cursor: pointer;"
                                                    >
                                                      <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configurTabIndex, emailLanguage.value, 'healthAndSaftyPolicyForms', 'taskReminderEmail')">{{ platform.platform_variable_name }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                          </b-row>
                                        </div>
                                        <b-form-group
                                          class="my-3"
                                          label="Email Subject"
                                        >
                                          <b-form-input
                                            v-model="configrationSettings[configurTabIndex].healthAndSaftyPolicy.emails[emailLanguage.value].taskReminderEmail.subject"
                                            size="sm"
                                          ></b-form-input>
                                        </b-form-group>
                                        <b-spinner
                                          v-if="healthAndSaftyPolicyFormsTasksReminderEmail"
                                          label="Spinning"
                                        ></b-spinner>
                                        <b-form-group
                                          v-else
                                          label="Email Body"
                                        >
                                          <wysiwyg v-model="configrationSettings[configurTabIndex].healthAndSaftyPolicy.emails[emailLanguage.value].taskReminderEmail.message" />
                                        </b-form-group>
                                      </b-tab>
                                      <b-tab title="Tasks Completion Email">
                                        <label class="mt-3 mb-0">Tasks Completion Email</label>
                                        <div class="my-2">
                                          <b-row>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(tags, tagsIndex) in configrationSettings[configurTabIndex].configration.emailTags"
                                                    :key="tagsIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge variant="success">
                                                      <p @click="setTagValue('[['+tags.text+']]', configurTabIndex, emailLanguage.value, 'healthAndSaftyPolicyForms', 'taskCompletionEmail')">{{ tags.text }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(platform, platformIndex) in configrationSettings[configurTabIndex].configration.platformSettings"
                                                    :key="platformIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge
                                                      variant="success"
                                                      style="cursor: pointer;"
                                                    >
                                                      <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configurTabIndex, emailLanguage.value, 'healthAndSaftyPolicyForms', 'taskCompletionEmail')">{{ platform.platform_variable_name }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                          </b-row>
                                        </div>
                                        <b-form-group
                                          class="my-3"
                                          label="Email Subject"
                                        >
                                          <b-form-input
                                            v-model="configrationSettings[configurTabIndex].healthAndSaftyPolicy.emails[emailLanguage.value].taskCompletionEmail.subject"
                                            size="sm"
                                          ></b-form-input>
                                        </b-form-group>
                                        <b-spinner
                                          v-if="healthAndSaftyPolicyFormsTasksCompletionEmail"
                                          label="Spinning"
                                        ></b-spinner>
                                        <b-form-group
                                          v-else
                                          label="Email Body"
                                        >
                                          <wysiwyg v-model="configrationSettings[configurTabIndex].healthAndSaftyPolicy.emails[emailLanguage.value].taskCompletionEmail.message" />
                                        </b-form-group>
                                      </b-tab>
                                      <b-tab title="Renew Tasks Email">
                                        <label class="mt-3 mb-0">Renew Tasks Email</label>
                                        <div class="my-2">
                                          <b-row>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(tags, tagsIndex) in configrationSettings[configurTabIndex].configration.emailTags"
                                                    :key="tagsIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge variant="success">
                                                      <p @click="setTagValue('[['+tags.text+']]', configurTabIndex, emailLanguage.value, 'healthAndSaftyPolicyForms', 'renewTasksEmail')">{{ tags.text }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(platform, platformIndex) in configrationSettings[configurTabIndex].configration.platformSettings"
                                                    :key="platformIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge
                                                      variant="success"
                                                      style="cursor: pointer;"
                                                    >
                                                      <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configurTabIndex, emailLanguage.value, 'healthAndSaftyPolicyForms', 'renewTasksEmail')">{{ platform.platform_variable_name }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                          </b-row>
                                        </div>
                                        <b-form-group
                                          class="my-3"
                                          label="Email Subject"
                                        >
                                          <b-form-input
                                            v-model="configrationSettings[configurTabIndex].healthAndSaftyPolicy.emails[emailLanguage.value].renewTasksEmail.subject"
                                            size="sm"
                                          ></b-form-input>
                                        </b-form-group>
                                        <b-spinner
                                          v-if="healthAndSaftyPolicyFormsRenewTasksEmail"
                                          label="Spinning"
                                        ></b-spinner>
                                        <b-form-group
                                          v-else
                                          label="Email Body"
                                        >
                                          <wysiwyg v-model="configrationSettings[configurTabIndex].healthAndSaftyPolicy.emails[emailLanguage.value].renewTasksEmail.message" />
                                        </b-form-group>
                                      </b-tab>
                                      <b-tab
                                        title="Additional Tasks Email"
                                        v-if="isShowAdditionlTaskEmail"
                                      >
                                        <label class="mt-3 mb-0">Additional Tasks Email</label>
                                        <div class="my-2">
                                          <b-row>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(tags, tagsIndex) in configrationSettings[configurTabIndex].configration.emailTags"
                                                    :key="tagsIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge variant="success">
                                                      <p @click="setTagValue('[['+tags.text+']]', configurTabIndex, emailLanguage.value, 'healthAndSaftyPolicyForms', 'additionalTasksEmail')">{{ tags.text }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(platform, platformIndex) in configrationSettings[configurTabIndex].configration.platformSettings"
                                                    :key="platformIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge
                                                      variant="success"
                                                      style="cursor: pointer;"
                                                    >
                                                      <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configurTabIndex, emailLanguage.value, 'healthAndSaftyPolicyForms', 'additionalTasksEmail')">{{ platform.platform_variable_name }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                          </b-row>
                                        </div>
                                        <b-form-group
                                          class="my-3"
                                          label="Email Subject"
                                        >
                                          <b-form-input
                                            v-model="configrationSettings[configurTabIndex].healthAndSaftyPolicy.emails[emailLanguage.value].additionalTasksEmail.subject"
                                            size="sm"
                                          ></b-form-input>
                                        </b-form-group>
                                        <b-spinner
                                          v-if="healthAndSaftyPolicyAdditionalTasksEmail"
                                          label="Spinning"
                                        ></b-spinner>
                                        <b-form-group
                                          v-else
                                          label="Email Body"
                                        >
                                          <wysiwyg v-model="configrationSettings[configurTabIndex].healthAndSaftyPolicy.emails[emailLanguage.value].additionalTasksEmail.message" />
                                        </b-form-group>
                                      </b-tab>
                                    </b-tabs>
                                  </b-tab>
                                </b-tabs>
                              </b-card>
                            </b-tab>
                          </b-tabs>
                        </b-tab>
                        <b-tab
                          title="Health & safety Training"
                          title-item-class="fit-width"
                        >
                          <b-tabs>
                            <b-tab title="Forms">
                              <b-form-group
                                label="Select Health & safety Training Forms"
                                class="mt-4"
                              >
                                <b-form-checkbox
                                  inline
                                  v-model="configrationSettings[configurTabIndex].healthAndSaftyTraining.forms"
                                  v-for="(forms, index) in healthAndSaftyTrainingFormsOptions"
                                  :key="index"
                                  :value="{value:forms.value, reletedFormIds:forms.reletedFormIds}"
                                >{{ forms.text }}</b-form-checkbox>
                              </b-form-group>
                            </b-tab>
                            <b-tab title="Email">
                              <b-card>
                                <b-tabs
                                  small
                                  nav-class="employee-languages-tabs-layout"
                                >
                                  <b-tab
                                    v-for="(emailLanguage, lanuageIndex) in selectedLanguage"
                                    :key="lanuageIndex"
                                    :title="emailLanguage.text"
                                  >
                                    <b-tabs
                                      justified
                                      vertical
                                      pills
                                      small
                                      fill
                                    >
                                      <b-tab title="Tasks Email">
                                        <label class="mt-3 mb-0">Tasks Email</label>
                                        <div class="my-2">
                                          <b-row>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(tags, tagsIndex) in configrationSettings[configurTabIndex].configration.emailTags"
                                                    :key="tagsIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge
                                                      variant="success"
                                                      style="cursor: pointer;"
                                                    >
                                                      <p @click="setTagValue('[['+tags.text+']]', configurTabIndex, emailLanguage.value, 'healthAndSaftyTrainingForms', 'tasksEmail')">{{ tags.text }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(platform, platformIndex) in configrationSettings[configurTabIndex].configration.platformSettings"
                                                    :key="platformIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge
                                                      variant="success"
                                                      style="cursor: pointer;"
                                                    >
                                                      <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configurTabIndex, emailLanguage.value, 'healthAndSaftyTrainingForms', 'tasksEmail')">{{ platform.platform_variable_name }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                          </b-row>
                                        </div>
                                        <b-form-group
                                          class="my-3"
                                          label="Email Subject"
                                        >
                                          <b-form-input
                                            v-model="configrationSettings[configurTabIndex].healthAndSaftyTraining.emails[emailLanguage.value].tasksEmail.subject"
                                            size="sm"
                                          ></b-form-input>
                                        </b-form-group>
                                        <b-spinner
                                          v-if="healthAndSaftyTrainingFormsTasksEmail"
                                          label="Spinning"
                                        ></b-spinner>
                                        <b-form-group
                                          v-else
                                          label="Email Body"
                                        >
                                          <wysiwyg v-model="configrationSettings[configurTabIndex].healthAndSaftyTraining.emails[emailLanguage.value].tasksEmail.message" />
                                        </b-form-group>
                                      </b-tab>
                                      <b-tab title="Tasks Reminder Email">
                                        <label class="mt-3 mb-0">Tasks Reminder Email</label>
                                        <div class="my-2">
                                          <b-row>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(tags, tagsIndex) in configrationSettings[configurTabIndex].configration.emailTags"
                                                    :key="tagsIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge variant="success">
                                                      <p @click="setTagValue('[['+tags.text+']]', configurTabIndex, emailLanguage.value, 'healthAndSaftyTrainingForms', 'taskReminderEmail')">{{ tags.text }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(platform, platformIndex) in configrationSettings[configurTabIndex].configration.platformSettings"
                                                    :key="platformIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge
                                                      variant="success"
                                                      style="cursor: pointer;"
                                                    >
                                                      <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configurTabIndex, emailLanguage.value, 'healthAndSaftyTrainingForms', 'taskReminderEmail')">{{ platform.platform_variable_name }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                          </b-row>
                                        </div>
                                        <b-form-group
                                          class="my-3"
                                          label="Email Subject"
                                        >
                                          <b-form-input
                                            v-model="configrationSettings[configurTabIndex].healthAndSaftyTraining.emails[emailLanguage.value].taskReminderEmail.subject"
                                            size="sm"
                                          ></b-form-input>
                                        </b-form-group>
                                        <b-spinner
                                          v-if="healthAndSaftyTrainingFormsTasksReminderEmail"
                                          label="Spinning"
                                        ></b-spinner>
                                        <b-form-group
                                          v-else
                                          label="Email Body"
                                        >
                                          <wysiwyg v-model="configrationSettings[configurTabIndex].healthAndSaftyTraining.emails[emailLanguage.value].taskReminderEmail.message" />
                                        </b-form-group>
                                      </b-tab>
                                      <b-tab title="Tasks Completion Email">
                                        <label class="mt-3 mb-0">Tasks Completion Email</label>
                                        <div class="my-2">
                                          <b-row>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(tags, tagsIndex) in configrationSettings[configurTabIndex].configration.emailTags"
                                                    :key="tagsIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge variant="success">
                                                      <p @click="setTagValue('[['+tags.text+']]', configurTabIndex, emailLanguage.value, 'healthAndSaftyTrainingForms', 'taskCompletionEmail')">{{ tags.text }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(platform, platformIndex) in configrationSettings[configurTabIndex].configration.platformSettings"
                                                    :key="platformIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge
                                                      variant="success"
                                                      style="cursor: pointer;"
                                                    >
                                                      <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configurTabIndex, emailLanguage.value, 'healthAndSaftyTrainingForms', 'taskCompletionEmail')">{{ platform.platform_variable_name }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                          </b-row>
                                        </div>
                                        <b-form-group
                                          class="my-3"
                                          label="Email Subject"
                                        >
                                          <b-form-input
                                            v-model="configrationSettings[configurTabIndex].healthAndSaftyTraining.emails[emailLanguage.value].taskCompletionEmail.subject"
                                            size="sm"
                                          ></b-form-input>
                                        </b-form-group>
                                        <b-spinner
                                          v-if="healthAndSaftyTrainingFormsTasksCompletionEmail"
                                          label="Spinning"
                                        ></b-spinner>
                                        <b-form-group
                                          v-else
                                          label="Email Body"
                                        >
                                          <wysiwyg v-model="configrationSettings[configurTabIndex].healthAndSaftyTraining.emails[emailLanguage.value].taskCompletionEmail.message" />
                                        </b-form-group>
                                      </b-tab>
                                      <b-tab title="Renew Tasks Email">
                                        <label class="mt-3 mb-0">Renew Tasks Email</label>
                                        <div class="my-2">
                                          <b-row>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(tags, tagsIndex) in configrationSettings[configurTabIndex].configration.emailTags"
                                                    :key="tagsIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge variant="success">
                                                      <p @click="setTagValue('[['+tags.text+']]', configurTabIndex, emailLanguage.value, 'healthAndSaftyTrainingForms', 'renewTasksEmail')">{{ tags.text }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(platform, platformIndex) in configrationSettings[configurTabIndex].configration.platformSettings"
                                                    :key="platformIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge
                                                      variant="success"
                                                      style="cursor: pointer;"
                                                    >
                                                      <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configurTabIndex, emailLanguage.value, 'healthAndSaftyTrainingForms', 'renewTasksEmail')">{{ platform.platform_variable_name }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                          </b-row>
                                        </div>
                                        <b-form-group
                                          class="my-3"
                                          label="Email Subject"
                                        >
                                          <b-form-input
                                            v-model="configrationSettings[configurTabIndex].healthAndSaftyTraining.emails[emailLanguage.value].renewTasksEmail.subject"
                                            size="sm"
                                          ></b-form-input>
                                        </b-form-group>
                                        <b-spinner
                                          v-if="healthAndSaftyTrainingFormsRenewTasksEmail"
                                          label="Spinning"
                                        ></b-spinner>
                                        <b-form-group
                                          v-else
                                          label="Email Body"
                                        >
                                          <wysiwyg v-model="configrationSettings[configurTabIndex].healthAndSaftyTraining.emails[emailLanguage.value].renewTasksEmail.message" />
                                        </b-form-group>
                                      </b-tab>
                                      <b-tab
                                        title="Additional Tasks Email"
                                        v-if="isShowAdditionlTaskEmail"
                                      >
                                        <label class="mt-3 mb-0">Additional Tasks Email</label>
                                        <div class="my-2">
                                          <b-row>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(tags, tagsIndex) in configrationSettings[configurTabIndex].configration.emailTags"
                                                    :key="tagsIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge variant="success">
                                                      <p @click="setTagValue('[['+tags.text+']]', configurTabIndex, emailLanguage.value, 'healthAndSaftyTrainingForms', 'additionalTasksEmail')">{{ tags.text }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                            <b-col cols="6">
                                              <b-card>
                                                <b-card-body
                                                  class="p-0"
                                                  style="height: 70px;overflow-y: auto;"
                                                >
                                                  <span
                                                    v-for="(platform, platformIndex) in configrationSettings[configurTabIndex].configration.platformSettings"
                                                    :key="platformIndex"
                                                    class="mr-2"
                                                  >
                                                    <b-badge
                                                      variant="success"
                                                      style="cursor: pointer;"
                                                    >
                                                      <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configurTabIndex, emailLanguage.value, 'healthAndSaftyTrainingForms', 'additionalTasksEmail')">{{ platform.platform_variable_name }}</p>
                                                    </b-badge>
                                                  </span>
                                                </b-card-body>
                                              </b-card>
                                            </b-col>
                                          </b-row>
                                        </div>
                                        <b-form-group
                                          class="my-3"
                                          label="Email Subject"
                                        >
                                          <b-form-input
                                            v-model="configrationSettings[configurTabIndex].healthAndSaftyTraining.emails[emailLanguage.value].additionalTasksEmail.subject"
                                            size="sm"
                                          ></b-form-input>
                                        </b-form-group>
                                        <b-spinner
                                          v-if="healthAndSaftyTrainingAdditionalTasksEmail"
                                          label="Spinning"
                                        ></b-spinner>
                                        <b-form-group
                                          v-else
                                          label="Email Body"
                                        >
                                          <wysiwyg v-model="configrationSettings[configurTabIndex].healthAndSaftyTraining.emails[emailLanguage.value].additionalTasksEmail.message" />
                                        </b-form-group>
                                      </b-tab>
                                    </b-tabs>
                                  </b-tab>
                                </b-tabs>
                              </b-card>
                            </b-tab>
                          </b-tabs>
                        </b-tab>
                        <b-tab title="Email">
                          <b-card>
                            <b-tabs
                              small
                              nav-class="employee-email-languages-tabs-layout"
                            >
                              <b-tab
                                v-for="(emailLanguage, lanuageIndex) in selectedLanguage"
                                :key="lanuageIndex"
                                :title="emailLanguage.text"
                              >
                                <b-tabs
                                  justified
                                  vertical
                                  pills
                                  small
                                  fill
                                >
                                  <b-tab title="Welcome Email">
                                    <label class="mt-3 mb-0">Welcome Email</label>
                                    <div class="my-2">
                                      <b-row>
                                        <b-col cols="6">
                                          <b-card>
                                            <b-card-body
                                              class="p-0"
                                              style="height: 70px;overflow-y: auto;"
                                            >
                                              <span
                                                v-for="(tags, tagsIndex) in configrationSettings[configurTabIndex].configration.emailTags"
                                                :key="tagsIndex"
                                                class="mr-2"
                                              >
                                                <b-badge
                                                  variant="success"
                                                  style="cursor: pointer;"
                                                >
                                                  <p @click="setTagValue('[['+tags.text+']]', configurTabIndex, emailLanguage.value, 'emails', 'welcomeEmail')">{{ tags.text }}</p>
                                                </b-badge>
                                              </span>
                                            </b-card-body>
                                          </b-card>
                                        </b-col>
                                        <b-col cols="6">
                                          <b-card>
                                            <b-card-body
                                              class="p-0"
                                              style="height: 70px;overflow-y: auto;"
                                            >
                                              <span
                                                v-for="(platform, platformIndex) in configrationSettings[configurTabIndex].configration.platformSettings"
                                                :key="platformIndex"
                                                class="mr-2"
                                              >
                                                <b-badge
                                                  variant="success"
                                                  style="cursor: pointer;"
                                                >
                                                  <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configurTabIndex, emailLanguage.value, 'emails', 'welcomeEmail')">{{ platform.platform_variable_name }}</p>
                                                </b-badge>
                                              </span>
                                            </b-card-body>
                                          </b-card>
                                        </b-col>
                                      </b-row>
                                    </div>
                                    <b-form-group
                                      class="my-3"
                                      label="Email Subject"
                                    >
                                      <b-form-input
                                        v-model="configrationSettings[configurTabIndex].emails[emailLanguage.value].welcomeEmail.subject"
                                        size="sm"
                                      ></b-form-input>
                                    </b-form-group>
                                    <b-spinner
                                      v-if="emailsWelcomeEmail"
                                      label="Spinning"
                                    ></b-spinner>
                                    <b-form-group
                                      v-else
                                      label="Email Body"
                                    >
                                      <wysiwyg v-model="configrationSettings[configurTabIndex].emails[emailLanguage.value].welcomeEmail.message" />
                                    </b-form-group>
                                  </b-tab>
                                  <b-tab title="Additional Tasks Email">
                                    <label class="mt-3 mb-0">Additional Tasks Email</label>
                                    <div class="my-2">
                                      <b-row>
                                        <b-col cols="6">
                                          <b-card>
                                            <b-card-body
                                              class="p-0"
                                              style="height: 70px;overflow-y: auto;"
                                            >
                                              <span
                                                v-for="(tags, tagsIndex) in configrationSettings[configurTabIndex].configration.emailTags"
                                                :key="tagsIndex"
                                                class="mr-2"
                                              >
                                                <b-badge
                                                  variant="success"
                                                  style="cursor: pointer;"
                                                >
                                                  <p @click="setTagValue('[['+tags.text+']]', configurTabIndex, emailLanguage.value, 'emails', 'additionalTasksEmail')">{{ tags.text }}</p>
                                                </b-badge>
                                              </span>
                                            </b-card-body>
                                          </b-card>
                                        </b-col>
                                        <b-col cols="6">
                                          <b-card>
                                            <b-card-body
                                              class="p-0"
                                              style="height: 70px;overflow-y: auto;"
                                            >
                                              <span
                                                v-for="(platform, platformIndex) in configrationSettings[configurTabIndex].configration.platformSettings"
                                                :key="platformIndex"
                                                class="mr-2"
                                              >
                                                <b-badge
                                                  variant="success"
                                                  style="cursor: pointer;"
                                                >
                                                  <p @click="setTagValue('{{'+platform.platform_variable_key+'}}', configurTabIndex, emailLanguage.value, 'emails', 'additionalTasksEmail')">{{ platform.platform_variable_name }}</p>
                                                </b-badge>
                                              </span>
                                            </b-card-body>
                                          </b-card>
                                        </b-col>
                                      </b-row>
                                    </div>
                                    <b-form-group
                                      class="my-3"
                                      label="Email Subject"
                                    >
                                      <b-form-input
                                        v-model="configrationSettings[configurTabIndex].emails[emailLanguage.value].additionalTasksEmail.subject"
                                        size="sm"
                                      ></b-form-input>
                                    </b-form-group>
                                    <b-spinner
                                      v-if="emailsAdditionalTasksEmail"
                                      label="Spinning"
                                    ></b-spinner>
                                    <b-form-group
                                      v-else
                                      label="Email Body"
                                    >
                                      <wysiwyg v-model="configrationSettings[configurTabIndex].emails[emailLanguage.value].additionalTasksEmail.message" />
                                    </b-form-group>
                                  </b-tab>
                                </b-tabs>
                              </b-tab>
                            </b-tabs>
                          </b-card>
                        </b-tab>
                      </b-tabs>
                    </b-card>
                  </b-tab>
                </b-tabs>
              </b-tab>
            </b-tabs>
          </b-overlay>
        </div>
        <div v-else-if="submiting && !responseSuccess">
          <p>
            {{
              isEditWorkFlow
                ? "Your Workflow is being Updating......"
                : isDuplicateWorkFlow
                ? "Your Workflow is being duplicating......"
                : "Your Workflow is being Creating......"
            }}
          </p>
          <b-spinner
            type="grow"
            label="Loading..."
          ></b-spinner>
        </div>
        <div v-else>
          <p class="my-2 text-center">
            {{
              isEditWorkFlow
                ? "Your Workflow has been updated successfully."
                : isDuplicateWorkFlow
                ? "Your Workflow has been Duplicated successfully."
                : "Your Workflow has been added successfully."
            }}
            <br />
          </p>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button
          v-if="!submiting"
          @click="closeModal"
          variant="outline-danger"
        >Close</b-button>
        <b-button
          v-if="!submiting && !responseSuccess"
          @click="checkValidation"
          variant="outline-success"
        >{{
            isEditWorkFlow
              ? "Update"
              : isDuplicateWorkFlow
              ? "Duplicate"
              : "Save "
          }}</b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { HTTP } from "../../../../utils/HTTP";
import { EventBus } from "@/event-bus.js";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import "moment/locale/es";
// import CountryCodes from "../../utils/countryCodes.json";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
export default {
  name: "AddNewEmployeeModal",
  mixins: [validationMixin],
  components: {
    Datepicker,
  },
  data () {
    return {
      isShowAdditionlTaskEmail: false, // // mark this variable true to show Additionl Tasks Email in all tabs
      isEditWorkFlow: false,
      showAddModal: false,
      form: {
        title: null,
        version: null,
      },
      tasksEmailEmailTags: [],
      emailTagsOptions: [],
      platformSettingOptions: [],
      languagesOptions: [],
      selectedLanguage: [{ text: "English", value: "1" }],
      healthAndSaftyPolicyFormsOptions: [],
      healthAndSaftyTrainingFormsOptions: [],
      policyFormsOptions: [],
      trainingFormsOptions: [],
      certificationFormsOptions: [],
      totalRows: 0,
      filter: null,
      perPage: 10,
      currentPage: 1,
      sortBy: "id",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 75, 100],
      staticFields: [
        { key: "id", label: "id", sortable: true },
        { key: "type", label: "Type", sortable: true },
        { key: "title", sortable: true },
        { key: "company_name", label: "Company Name", sortable: true },
        { key: "name", label: "Creator Name", sortable: true },
        { key: "created_updated", sortable: true },
      ],
      items: [
        {
          id: "1",
          type: "External Questionaire",
          title: "ST Engineering Due Diligence Questionnaire",
          company_name: "Shockwave Medical, Inc.",
          name: "Karan Jain",
          created_updated: "6 months ago",
        },
        {
          id: "2",
          type: "Training",
          title: "Carasol Test",
          company_name: "DS Dealers Test",
          name: "Karan Jain",
          created_updated: "a months ago",
        },
        {
          id: "3",
          type: "Training",
          title: "frweraeds",
          company_name: "STE Company QA",
          name: "Karan Jain",
          created_updated: "a months ago",
        },
      ],
      configrationSettings: [
        {
          title: null,
          startDate: null,
          endDateValue: null,
          certificationAndTrainingDate: null,
          configration: {
            emailTags: [],
            platformSettings: []
          },
          policyForms: {
            forms: [],
            emails: null,
          },
          trainingForms: {
            forms: [],
            emails: null,
          },
          certificationForms: {
            forms: [],
            emails: null,
          },
          healthAndSaftyPolicy: {
            forms: [],
            emails: null,
          },
          healthAndSaftyTraining: {
            forms: [],
            emails: null,
          },
          emails: null,
        },
      ],
      submiting: false,
      isLoading: false,
      responseSuccess: false,
      workflowSettingId: null,
      invalidTitleValue: null,
      invalidStartDateValue: null,
      invalidCertificationAndTrainingDateValue: null,
      invalidEndDateValue: null,
      configurationTitleIndex: null,
      configurationStartDateIndex: null,
      configurationCertificationAndTrainingDateIndex: null,
      configurationEndDateIndex: null,
      isDuplicateWorkFlow: false,
      selectedLanguageLength: null,
      formsEmails: {},
      setupEmails: {},
      policyEmails: {},
      trainingEmails: {},
      certificationFormsEmails: {},
      healthAndSaftyPolicyFormsEmails: {},
      healthAndSaftyTrainingFormsEmails: {},
      policyFormsTasksEmail: false,
      policyFormsTasksReminderEmail: false,
      policyFormsTasksCompletionEmail: false,
      policyFormsRenewTasksEmail: false,
      policyFormsAdditionalTasksEmail: false,
      healthAndSaftyPolicyFormsTasksEmail: false,
      healthAndSaftyPolicyFormsTasksReminderEmail: false,
      healthAndSaftyPolicyFormsTasksCompletionEmail: false,
      healthAndSaftyPolicyFormsRenewTasksEmail: false,
      healthAndSaftyPolicyAdditionalTasksEmail: false,
      healthAndSaftyTrainingFormsTasksEmail: false,
      healthAndSaftyTrainingFormsTasksReminderEmail: false,
      healthAndSaftyTrainingFormsTasksCompletionEmail: false,
      healthAndSaftyTrainingFormsRenewTasksEmail: false,
      healthAndSaftyTrainingAdditionalTasksEmail: false,
      trainingFormsTasksEmail: false,
      trainingFormsTasksReminderEmail: false,
      trainingFormsRenewTasksEmail: false,
      trainingFormsTasksCompletionEmail: false,
      trainingFormsAdditionalTasksEmail: false,
      certificationFormsTasksEmail: false,
      certificationFormsTasksReminderEmail: false,
      certificationFormsTasksCompletionEmail: false,
      certificationFormsRenewTasksEmail: false,
      certificationFormsTasksBreachEmail: false,
      certificationFormsAdditionalTasksEmail: false,
      emailsWelcomeEmail: false,
      emailsAdditionalTasksEmail: false,
      emailsTasksEmail: false,
      emailsTaskCompletionEmail: false,
      emailsTaskReminderEmail: false,
      loadingEmployeeData: false
    };
  },
  validations: {
    form: {
      title: { required },
      version: { required },
    },
  },
  created () {
    EventBus.$on( "onShowAddNewEmployeeModal", () => {
      this.showAddNewEmployeeModal();
    } );
    EventBus.$on( "onShowEditWorkflowSettingModal", ( value ) => {
      this.showEditWorkflowModal( value );
    } );
    EventBus.$on( "onShowDuplicateWorkflowSettingModal", ( value ) => {
      this.showDuplicateWorkflowModal( value );
    } );
  },
  computed: {
    rows () {
      return this.totalRows;
    },
  },
  mounted () {
    this.getEmployeeLanguages();
    this.getFormsOptions();
    this.getEmailTagsList();
    this.getPlatformSettingList();
  },
  methods: {
    setTagValue ( selectedValue, configurTabIndex, emailLanguageValue, formTab, emailTab ) {
      // in this function we are adding email tags or platform variables as per in which email type user stands
      // in selectedValue key it has email tag value or platform variable value as where user clicks with email tags are in mustache syntax like {{emailTagValue}} and platform variable value is in multidimensional array syntax like [[platformVariableValue]]
      // in configurTabIndex shows in which confiugration index object we have to added tag or variable
      // in emailLanguageValue shows in which language object user adding email tag or platform variable means in which language tab user stand
      // in formTab shows in which form tab user want to add email tag or platform variable like policy forms tab, training tab and certification Forms tab
      // in emailTab shows in which email type object user stand means in which email types object user want to add email tag or platform variable

      let tasksEmail = null;
      let taskReminderEmail = null;
      let taskCompletionEmail = null;
      let renewTasksEmail = null;
      let tasksBreachEmail = null;
      let welcomeEmail = null;
      let additionalTasksEmail = null;
      if ( formTab == 'policyForms' ) {
        if ( emailTab == 'tasksEmail' ) {
          if ( this.configrationSettings[configurTabIndex].policyForms.emails[emailLanguageValue].tasksEmail.message == null ) {
            this.configrationSettings[configurTabIndex].policyForms.emails[emailLanguageValue].tasksEmail.message = selectedValue
          } else {
            tasksEmail = this.configrationSettings[configurTabIndex].policyForms.emails[emailLanguageValue].tasksEmail.message + '' + selectedValue;
            this.configrationSettings[configurTabIndex].policyForms.emails[emailLanguageValue].tasksEmail.message = tasksEmail;
          }
          this.policyFormsTasksEmail = true;
          setTimeout( () => {
            this.policyFormsTasksEmail = false;
          }, 100 );
        }
        if ( emailTab == 'taskReminderEmail' ) {
          if ( this.configrationSettings[configurTabIndex].policyForms.emails[emailLanguageValue].taskReminderEmail.message == null ) {
            this.configrationSettings[configurTabIndex].policyForms.emails[emailLanguageValue].taskReminderEmail.message = selectedValue
          } else {
            taskReminderEmail = this.configrationSettings[configurTabIndex].policyForms.emails[emailLanguageValue].taskReminderEmail.message + '' + selectedValue;
            this.configrationSettings[configurTabIndex].policyForms.emails[emailLanguageValue].taskReminderEmail.message = taskReminderEmail;
          }
          this.policyFormsTasksReminderEmail = true;
          setTimeout( () => {
            this.policyFormsTasksReminderEmail = false;
          }, 100 );
        }
        if ( emailTab == 'taskCompletionEmail' ) {
          if ( this.configrationSettings[configurTabIndex].policyForms.emails[emailLanguageValue].taskCompletionEmail.message == null ) {
            this.configrationSettings[configurTabIndex].policyForms.emails[emailLanguageValue].taskCompletionEmail.message = selectedValue
          } else {
            taskCompletionEmail = this.configrationSettings[configurTabIndex].policyForms.emails[emailLanguageValue].taskCompletionEmail.message + '' + selectedValue;
            this.configrationSettings[configurTabIndex].policyForms.emails[emailLanguageValue].taskCompletionEmail.message = taskCompletionEmail;
          }
          this.policyFormsTasksCompletionEmail = true;
          setTimeout( () => {
            this.policyFormsTasksCompletionEmail = false;
          }, 100 );
        }
        if ( emailTab == 'renewTasksEmail' ) {
          if ( this.configrationSettings[configurTabIndex].policyForms.emails[emailLanguageValue].renewTasksEmail.message == null ) {
            this.configrationSettings[configurTabIndex].policyForms.emails[emailLanguageValue].renewTasksEmail.message = selectedValue
          } else {
            renewTasksEmail = this.configrationSettings[configurTabIndex].policyForms.emails[emailLanguageValue].renewTasksEmail.message + '' + selectedValue;
            this.configrationSettings[configurTabIndex].policyForms.emails[emailLanguageValue].renewTasksEmail.message = renewTasksEmail;
          }
          this.policyFormsRenewTasksEmail = true;
          setTimeout( () => {
            this.policyFormsRenewTasksEmail = false;
          }, 100 );
        }
        if ( emailTab == 'additionalTasksEmail' ) {
          if ( this.configrationSettings[configurTabIndex].policyForms.emails[emailLanguageValue].additionalTasksEmail.message == null ) {
            this.configrationSettings[configurTabIndex].policyForms.emails[emailLanguageValue].additionalTasksEmail.message = selectedValue
          } else {
            additionalTasksEmail = this.configrationSettings[configurTabIndex].policyForms.emails[emailLanguageValue].additionalTasksEmail.message + '' + selectedValue;
            this.configrationSettings[configurTabIndex].policyForms.emails[emailLanguageValue].additionalTasksEmail.message = additionalTasksEmail;
          }
          this.policyFormsAdditionalTasksEmail = true;
          setTimeout( () => {
            this.policyFormsAdditionalTasksEmail = false;
          }, 100 );
        }
      }
      if ( formTab == 'trainingForms' ) {
        if ( emailTab == 'tasksEmail' ) {
          if ( this.configrationSettings[configurTabIndex].trainingForms.emails[emailLanguageValue].tasksEmail.message == null ) {
            this.configrationSettings[configurTabIndex].trainingForms.emails[emailLanguageValue].tasksEmail.message = selectedValue
          } else {
            tasksEmail = this.configrationSettings[configurTabIndex].trainingForms.emails[emailLanguageValue].tasksEmail.message + '' + selectedValue;
            this.configrationSettings[configurTabIndex].trainingForms.emails[emailLanguageValue].tasksEmail.message = tasksEmail;
          }
          this.trainingFormsTasksEmail = true;
          setTimeout( () => {
            this.trainingFormsTasksEmail = false;
          }, 100 );
        }
        if ( emailTab == 'taskReminderEmail' ) {
          if ( this.configrationSettings[configurTabIndex].trainingForms.emails[emailLanguageValue].taskReminderEmail.message == null ) {
            this.configrationSettings[configurTabIndex].trainingForms.emails[emailLanguageValue].taskReminderEmail.message = selectedValue
          } else {
            taskReminderEmail = this.configrationSettings[configurTabIndex].trainingForms.emails[emailLanguageValue].taskReminderEmail.message + '' + selectedValue;
            this.configrationSettings[configurTabIndex].trainingForms.emails[emailLanguageValue].taskReminderEmail.message = taskReminderEmail;
          }
          this.trainingFormsTasksReminderEmail = true;
          setTimeout( () => {
            this.trainingFormsTasksReminderEmail = false;
          }, 100 );
        }
        if ( emailTab == 'taskCompletionEmail' ) {
          if ( this.configrationSettings[configurTabIndex].trainingForms.emails[emailLanguageValue].taskCompletionEmail.message == null ) {
            this.configrationSettings[configurTabIndex].trainingForms.emails[emailLanguageValue].taskCompletionEmail.message = selectedValue
          } else {
            taskCompletionEmail = this.configrationSettings[configurTabIndex].trainingForms.emails[emailLanguageValue].taskCompletionEmail.message + '' + selectedValue;
            this.configrationSettings[configurTabIndex].trainingForms.emails[emailLanguageValue].taskCompletionEmail.message = taskCompletionEmail;
          }
          this.trainingFormsTasksCompletionEmail = true;
          setTimeout( () => {
            this.trainingFormsTasksCompletionEmail = false;
          }, 100 );
        }
        if ( emailTab == 'renewTasksEmail' ) {
          if ( this.configrationSettings[configurTabIndex].trainingForms.emails[emailLanguageValue].renewTasksEmail.message == null ) {
            this.configrationSettings[configurTabIndex].trainingForms.emails[emailLanguageValue].renewTasksEmail.message = selectedValue
          } else {
            renewTasksEmail = this.configrationSettings[configurTabIndex].trainingForms.emails[emailLanguageValue].renewTasksEmail.message + '' + selectedValue;
            this.configrationSettings[configurTabIndex].trainingForms.emails[emailLanguageValue].renewTasksEmail.message = renewTasksEmail;
          }
          this.trainingFormsRenewTasksEmail = true;
          setTimeout( () => {
            this.trainingFormsRenewTasksEmail = false;
          }, 100 );
        }
        if ( emailTab == 'additionalTasksEmail' ) {
          if ( this.configrationSettings[configurTabIndex].trainingForms.emails[emailLanguageValue].additionalTasksEmail.message == null ) {
            this.configrationSettings[configurTabIndex].trainingForms.emails[emailLanguageValue].additionalTasksEmail.message = selectedValue
          } else {
            additionalTasksEmail = this.configrationSettings[configurTabIndex].trainingForms.emails[emailLanguageValue].additionalTasksEmail.message + '' + selectedValue;
            this.configrationSettings[configurTabIndex].trainingForms.emails[emailLanguageValue].additionalTasksEmail.message = additionalTasksEmail;
          }
          this.trainingFormsAdditionalTasksEmail = true;
          setTimeout( () => {
            this.trainingFormsAdditionalTasksEmail = false;
          }, 100 );
        }
      }
      if ( formTab == 'certificationForms' ) {
        if ( emailTab == 'tasksEmail' ) {
          if ( this.configrationSettings[configurTabIndex].certificationForms.emails[emailLanguageValue].tasksEmail.message == null ) {
            this.configrationSettings[configurTabIndex].certificationForms.emails[emailLanguageValue].tasksEmail.message = selectedValue
          } else {
            tasksEmail = this.configrationSettings[configurTabIndex].certificationForms.emails[emailLanguageValue].tasksEmail.message + '' + selectedValue;
            this.configrationSettings[configurTabIndex].certificationForms.emails[emailLanguageValue].tasksEmail.message = tasksEmail;
          }
          this.certificationFormsTasksEmail = true;
          setTimeout( () => {
            this.certificationFormsTasksEmail = false;
          }, 100 );
        }
        if ( emailTab == 'taskReminderEmail' ) {
          if ( this.configrationSettings[configurTabIndex].certificationForms.emails[emailLanguageValue].taskReminderEmail.message == null ) {
            this.configrationSettings[configurTabIndex].certificationForms.emails[emailLanguageValue].taskReminderEmail.message = selectedValue
          } else {
            taskReminderEmail = this.configrationSettings[configurTabIndex].certificationForms.emails[emailLanguageValue].taskReminderEmail.message + '' + selectedValue;
            this.configrationSettings[configurTabIndex].certificationForms.emails[emailLanguageValue].taskReminderEmail.message = taskReminderEmail;
          }
          this.certificationFormsTasksReminderEmail = true;
          setTimeout( () => {
            this.certificationFormsTasksReminderEmail = false;
          }, 100 );
        }
        if ( emailTab == 'taskCompletionEmail' ) {
          if ( this.configrationSettings[configurTabIndex].certificationForms.emails[emailLanguageValue].taskCompletionEmail.message == null ) {
            this.configrationSettings[configurTabIndex].certificationForms.emails[emailLanguageValue].taskCompletionEmail.message = selectedValue
          } else {
            taskCompletionEmail = this.configrationSettings[configurTabIndex].certificationForms.emails[emailLanguageValue].taskCompletionEmail.message + '' + selectedValue;
            this.configrationSettings[configurTabIndex].certificationForms.emails[emailLanguageValue].taskCompletionEmail.message = taskCompletionEmail;
          }
          this.certificationFormsTasksCompletionEmail = true;
          setTimeout( () => {
            this.certificationFormsTasksCompletionEmail = false;
          }, 100 );
        }
        if ( emailTab == 'renewTasksEmail' ) {
          if ( this.configrationSettings[configurTabIndex].certificationForms.emails[emailLanguageValue].renewTasksEmail.message == null ) {
            this.configrationSettings[configurTabIndex].certificationForms.emails[emailLanguageValue].renewTasksEmail.message = selectedValue
          } else {
            renewTasksEmail = this.configrationSettings[configurTabIndex].certificationForms.emails[emailLanguageValue].renewTasksEmail.message + '' + selectedValue;
            this.configrationSettings[configurTabIndex].certificationForms.emails[emailLanguageValue].renewTasksEmail.message = renewTasksEmail;
          }
          this.certificationFormsRenewTasksEmail = true;
          setTimeout( () => {
            this.certificationFormsRenewTasksEmail = false;
          }, 100 );
        }
        if ( emailTab == 'tasksBreachEmail' ) {
          if ( this.configrationSettings[configurTabIndex].certificationForms.emails[emailLanguageValue].tasksBreachEmail.message == null ) {
            this.configrationSettings[configurTabIndex].certificationForms.emails[emailLanguageValue].tasksBreachEmail.message = selectedValue
          } else {
            tasksBreachEmail = this.configrationSettings[configurTabIndex].certificationForms.emails[emailLanguageValue].tasksBreachEmail.message + '' + selectedValue;
            this.configrationSettings[configurTabIndex].certificationForms.emails[emailLanguageValue].tasksBreachEmail.message = tasksBreachEmail;
          }
          this.certificationFormsTasksBreachEmail = true;
          setTimeout( () => {
            this.certificationFormsTasksBreachEmail = false;
          }, 100 );
        }
        if ( emailTab == 'additionalTasksEmail' ) {
          if ( this.configrationSettings[configurTabIndex].certificationForms.emails[emailLanguageValue].additionalTasksEmail.message == null ) {
            this.configrationSettings[configurTabIndex].certificationForms.emails[emailLanguageValue].additionalTasksEmail.message = selectedValue
          } else {
            additionalTasksEmail = this.configrationSettings[configurTabIndex].certificationForms.emails[emailLanguageValue].additionalTasksEmail.message + '' + selectedValue;
            this.configrationSettings[configurTabIndex].certificationForms.emails[emailLanguageValue].additionalTasksEmail.message = additionalTasksEmail;
          }
          this.certificationFormsAdditionalTasksEmail = true;
          setTimeout( () => {
            this.certificationFormsAdditionalTasksEmail = false;
          }, 100 );
        }
      }
      if ( formTab == 'healthAndSaftyPolicyForms' ) {
        if ( emailTab == 'tasksEmail' ) {
          if ( this.configrationSettings[configurTabIndex].healthAndSaftyPolicy.emails[emailLanguageValue].tasksEmail.message == null ) {
            this.configrationSettings[configurTabIndex].healthAndSaftyPolicy.emails[emailLanguageValue].tasksEmail.message = selectedValue
          } else {
            tasksEmail = this.configrationSettings[configurTabIndex].healthAndSaftyPolicy.emails[emailLanguageValue].tasksEmail.message + '' + selectedValue;
            this.configrationSettings[configurTabIndex].healthAndSaftyPolicy.emails[emailLanguageValue].tasksEmail.message = tasksEmail;
          }
          this.healthAndSaftyPolicyFormsTasksEmail = true;
          setTimeout( () => {
            this.healthAndSaftyPolicyFormsTasksEmail = false;
          }, 100 );
        }
        if ( emailTab == 'taskReminderEmail' ) {
          if ( this.configrationSettings[configurTabIndex].healthAndSaftyPolicy.emails[emailLanguageValue].taskReminderEmail.message == null ) {
            this.configrationSettings[configurTabIndex].healthAndSaftyPolicy.emails[emailLanguageValue].taskReminderEmail.message = selectedValue
          } else {
            taskReminderEmail = this.configrationSettings[configurTabIndex].healthAndSaftyPolicy.emails[emailLanguageValue].taskReminderEmail.message + '' + selectedValue;
            this.configrationSettings[configurTabIndex].healthAndSaftyPolicy.emails[emailLanguageValue].taskReminderEmail.message = taskReminderEmail;
          }
          this.healthAndSaftyPolicyFormsTasksReminderEmail = true;
          setTimeout( () => {
            this.healthAndSaftyPolicyFormsTasksReminderEmail = false;
          }, 100 );
        }
        if ( emailTab == 'taskCompletionEmail' ) {
          if ( this.configrationSettings[configurTabIndex].healthAndSaftyPolicy.emails[emailLanguageValue].taskCompletionEmail.message == null ) {
            this.configrationSettings[configurTabIndex].healthAndSaftyPolicy.emails[emailLanguageValue].taskCompletionEmail.message = selectedValue
          } else {
            taskCompletionEmail = this.configrationSettings[configurTabIndex].healthAndSaftyPolicy.emails[emailLanguageValue].taskCompletionEmail.message + '' + selectedValue;
            this.configrationSettings[configurTabIndex].healthAndSaftyPolicy.emails[emailLanguageValue].taskCompletionEmail.message = taskCompletionEmail;
          }
          this.healthAndSaftyPolicyFormsTasksCompletionEmail = true;
          setTimeout( () => {
            this.healthAndSaftyPolicyFormsTasksCompletionEmail = false;
          }, 100 );
        }
        if ( emailTab == 'renewTasksEmail' ) {
          if ( this.configrationSettings[configurTabIndex].healthAndSaftyPolicy.emails[emailLanguageValue].renewTasksEmail.message == null ) {
            this.configrationSettings[configurTabIndex].healthAndSaftyPolicy.emails[emailLanguageValue].renewTasksEmail.message = selectedValue
          } else {
            renewTasksEmail = this.configrationSettings[configurTabIndex].healthAndSaftyPolicy.emails[emailLanguageValue].renewTasksEmail.message + '' + selectedValue;
            this.configrationSettings[configurTabIndex].healthAndSaftyPolicy.emails[emailLanguageValue].renewTasksEmail.message = renewTasksEmail;
          }
          this.healthAndSaftyPolicyFormsRenewTasksEmail = true;
          setTimeout( () => {
            this.healthAndSaftyPolicyFormsRenewTasksEmail = false;
          }, 100 );
        }
        if ( emailTab == 'additionalTasksEmail' ) {
          if ( this.configrationSettings[configurTabIndex].healthAndSaftyPolicy.emails[emailLanguageValue].additionalTasksEmail.message == null ) {
            this.configrationSettings[configurTabIndex].healthAndSaftyPolicy.emails[emailLanguageValue].additionalTasksEmail.message = selectedValue
          } else {
            additionalTasksEmail = this.configrationSettings[configurTabIndex].healthAndSaftyPolicy.emails[emailLanguageValue].additionalTasksEmail.message + '' + selectedValue;
            this.configrationSettings[configurTabIndex].healthAndSaftyPolicy.emails[emailLanguageValue].additionalTasksEmail.message = additionalTasksEmail;
          }
          this.healthAndSaftyPolicyAdditionalTasksEmail = true;
          setTimeout( () => {
            this.healthAndSaftyPolicyAdditionalTasksEmail = false;
          }, 100 );
        }
      }
      if ( formTab == 'healthAndSaftyTrainingForms' ) {
        if ( emailTab == 'tasksEmail' ) {
          if ( this.configrationSettings[configurTabIndex].healthAndSaftyTraining.emails[emailLanguageValue].tasksEmail.message == null ) {
            this.configrationSettings[configurTabIndex].healthAndSaftyTraining.emails[emailLanguageValue].tasksEmail.message = selectedValue
          } else {
            tasksEmail = this.configrationSettings[configurTabIndex].healthAndSaftyTraining.emails[emailLanguageValue].tasksEmail.message + '' + selectedValue;
            this.configrationSettings[configurTabIndex].healthAndSaftyTraining.emails[emailLanguageValue].tasksEmail.message = tasksEmail;
          }
          this.healthAndSaftyTrainingFormsTasksEmail = true;
          setTimeout( () => {
            this.healthAndSaftyTrainingFormsTasksEmail = false;
          }, 100 );
        }
        if ( emailTab == 'taskReminderEmail' ) {
          if ( this.configrationSettings[configurTabIndex].healthAndSaftyTraining.emails[emailLanguageValue].taskReminderEmail.message == null ) {
            this.configrationSettings[configurTabIndex].healthAndSaftyTraining.emails[emailLanguageValue].taskReminderEmail.message = selectedValue
          } else {
            taskReminderEmail = this.configrationSettings[configurTabIndex].healthAndSaftyTraining.emails[emailLanguageValue].taskReminderEmail.message + '' + selectedValue;
            this.configrationSettings[configurTabIndex].healthAndSaftyTraining.emails[emailLanguageValue].taskReminderEmail.message = taskReminderEmail;
          }
          this.healthAndSaftyTrainingFormsTasksReminderEmail = true;
          setTimeout( () => {
            this.healthAndSaftyTrainingFormsTasksReminderEmail = false;
          }, 100 );
        }
        if ( emailTab == 'taskCompletionEmail' ) {
          if ( this.configrationSettings[configurTabIndex].healthAndSaftyTraining.emails[emailLanguageValue].taskCompletionEmail.message == null ) {
            this.configrationSettings[configurTabIndex].healthAndSaftyTraining.emails[emailLanguageValue].taskCompletionEmail.message = selectedValue
          } else {
            taskCompletionEmail = this.configrationSettings[configurTabIndex].healthAndSaftyTraining.emails[emailLanguageValue].taskCompletionEmail.message + '' + selectedValue;
            this.configrationSettings[configurTabIndex].healthAndSaftyTraining.emails[emailLanguageValue].taskCompletionEmail.message = taskCompletionEmail;
          }
          this.healthAndSaftyTrainingFormsTasksCompletionEmail = true;
          setTimeout( () => {
            this.healthAndSaftyTrainingFormsTasksCompletionEmail = false;
          }, 100 );
        }
        if ( emailTab == 'renewTasksEmail' ) {
          if ( this.configrationSettings[configurTabIndex].healthAndSaftyTraining.emails[emailLanguageValue].renewTasksEmail.message == null ) {
            this.configrationSettings[configurTabIndex].healthAndSaftyTraining.emails[emailLanguageValue].renewTasksEmail.message = selectedValue
          } else {
            renewTasksEmail = this.configrationSettings[configurTabIndex].healthAndSaftyTraining.emails[emailLanguageValue].renewTasksEmail.message + '' + selectedValue;
            this.configrationSettings[configurTabIndex].healthAndSaftyTraining.emails[emailLanguageValue].renewTasksEmail.message = renewTasksEmail;
          }
          this.healthAndSaftyTrainingFormsRenewTasksEmail = true;
          setTimeout( () => {
            this.healthAndSaftyTrainingFormsRenewTasksEmail = false;
          }, 100 );
        }
        if ( emailTab == 'additionalTasksEmail' ) {
          if ( this.configrationSettings[configurTabIndex].healthAndSaftyTraining.emails[emailLanguageValue].additionalTasksEmail.message == null ) {
            this.configrationSettings[configurTabIndex].healthAndSaftyTraining.emails[emailLanguageValue].additionalTasksEmail.message = selectedValue
          } else {
            additionalTasksEmail = this.configrationSettings[configurTabIndex].healthAndSaftyTraining.emails[emailLanguageValue].additionalTasksEmail.message + '' + selectedValue;
            this.configrationSettings[configurTabIndex].healthAndSaftyTraining.emails[emailLanguageValue].additionalTasksEmail.message = additionalTasksEmail;
          }
          this.healthAndSaftyTrainingAdditionalTasksEmail = true;
          setTimeout( () => {
            this.healthAndSaftyTrainingAdditionalTasksEmail = false;
          }, 100 );
        }
      }
      if ( formTab == 'emails' ) {
        if ( emailTab == 'welcomeEmail' ) {
          if ( this.configrationSettings[configurTabIndex].emails[emailLanguageValue].welcomeEmail.message == null ) {
            this.configrationSettings[configurTabIndex].emails[emailLanguageValue].welcomeEmail.message = selectedValue
          } else {
            welcomeEmail = this.configrationSettings[configurTabIndex].emails[emailLanguageValue].welcomeEmail.message + '' + selectedValue;
            this.configrationSettings[configurTabIndex].emails[emailLanguageValue].welcomeEmail.message = welcomeEmail;
          }
          this.emailsWelcomeEmail = true;
          setTimeout( () => {
            this.emailsWelcomeEmail = false;
          }, 100 );
        }
        if ( emailTab == 'additionalTasksEmail' ) {
          if ( this.configrationSettings[configurTabIndex].emails[emailLanguageValue].additionalTasksEmail.message == null ) {
            this.configrationSettings[configurTabIndex].emails[emailLanguageValue].additionalTasksEmail.message = selectedValue
          } else {
            additionalTasksEmail = this.configrationSettings[configurTabIndex].emails[emailLanguageValue].additionalTasksEmail.message + '' + selectedValue;
            this.configrationSettings[configurTabIndex].emails[emailLanguageValue].additionalTasksEmail.message = additionalTasksEmail;
          }
          this.emailsAdditionalTasksEmail = true;
          setTimeout( () => {
            this.emailsAdditionalTasksEmail = false;
          }, 100 );
        }
      }
    },
    setNewLanguageEmail () {
      // in this function in hasOwnProperty if condition we check that language value object already exist or not if exist then we take emails subject and message as per that language from settings and assign that value

      // or in else condition if we don't have that language object then we add that new language object
      this.configrationSettings.map( settings => {
        debugger
        this.policyEmails = {}
        this.healthAndSaftyPolicyFormsEmails = {}
        this.healthAndSaftyTrainingFormsEmails = {}
        this.trainingEmails = {}
        this.certificationFormsEmails = {}
        this.setupEmails = {}
        if ( this.selectedLanguageLength != this.selectedLanguage.length && settings.emails != null ) {
          this.selectedLanguage.map( ( languages ) => {
            let language = languages.value;
            if ( settings.policyForms.emails.hasOwnProperty( language ) ) {
              this.policyEmails[language] = {
                tasksEmail: {
                  subject: settings.policyForms.emails[language].tasksEmail.subject,
                  message: settings.policyForms.emails[language].tasksEmail.message,
                },
                taskReminderEmail: {
                  subject: settings.policyForms.emails[language].taskReminderEmail.subject,
                  message: settings.policyForms.emails[language].taskReminderEmail.message,
                },
                taskCompletionEmail: {
                  subject: settings.policyForms.emails[language].taskCompletionEmail.subject,
                  message: settings.policyForms.emails[language].taskCompletionEmail.message,
                },
                renewTasksEmail: {
                  subject: settings.policyForms.emails[language].renewTasksEmail.subject,
                  message: settings.policyForms.emails[language].renewTasksEmail.message,
                },
                additionalTasksEmail: {
                  subject: settings.policyForms.emails[language].additionalTasksEmail ? settings.policyForms.emails[language].additionalTasksEmail.subject : null,
                  message: settings.policyForms.emails[language].additionalTasksEmail ? settings.policyForms.emails[language].additionalTasksEmail.message : null,
                },
              };
              this.trainingEmails[language] = {
                tasksEmail: {
                  subject: settings.trainingForms.emails[language].tasksEmail.subject,
                  message: settings.trainingForms.emails[language].tasksEmail.message,
                },
                taskReminderEmail: {
                  subject: settings.trainingForms.emails[language].taskReminderEmail.subject,
                  message: settings.trainingForms.emails[language].taskReminderEmail.message,
                },
                taskCompletionEmail: {
                  subject: settings.trainingForms.emails[language].taskCompletionEmail.subject,
                  message: settings.trainingForms.emails[language].taskCompletionEmail.message,
                },
                renewTasksEmail: {
                  subject: settings.trainingForms.emails[language].renewTasksEmail.subject,
                  message: settings.trainingForms.emails[language].renewTasksEmail.message,
                },
                additionalTasksEmail: {
                  subject: settings.policyForms.emails[language].additionalTasksEmail ? settings.policyForms.emails[language].additionalTasksEmail.subject : null,
                  message: settings.policyForms.emails[language].additionalTasksEmail ? settings.policyForms.emails[language].additionalTasksEmail.message : null,
                },
              };
              this.certificationFormsEmails[language] = {
                tasksEmail: {
                  subject: settings.certificationForms.emails[language].tasksEmail.subject,
                  message: settings.certificationForms.emails[language].tasksEmail.message,
                },
                taskReminderEmail: {
                  subject: settings.certificationForms.emails[language].taskReminderEmail.subject,
                  message: settings.certificationForms.emails[language].taskReminderEmail.message,
                },
                taskCompletionEmail: {
                  subject: settings.certificationForms.emails[language].taskCompletionEmail.subject,
                  message: settings.certificationForms.emails[language].taskCompletionEmail.message,
                },
                renewTasksEmail: {
                  subject: settings.certificationForms.emails[language].renewTasksEmail.subject,
                  message: settings.certificationForms.emails[language].renewTasksEmail.message,
                },
                tasksBreachEmail: {
                  subject: settings.certificationForms.emails[language].tasksBreachEmail.subject,
                  message: settings.certificationForms.emails[language].tasksBreachEmail.message,
                },
                additionalTasksEmail: {
                  subject: settings.policyForms.emails[language].additionalTasksEmail ? settings.policyForms.emails[language].additionalTasksEmail.subject : null,
                  message: settings.policyForms.emails[language].additionalTasksEmail ? settings.policyForms.emails[language].additionalTasksEmail.message : null,
                },
              };
              this.setupEmails[language] = {
                welcomeEmail: {
                  subject: settings.emails[language].welcomeEmail.subject,
                  message: settings.emails[language].welcomeEmail.message,
                },
                additionalTasksEmail: {
                  subject: settings.emails[language].additionalTasksEmail ? settings.emails[language].additionalTasksEmail.subject : null,
                  message: settings.emails[language].additionalTasksEmail ? settings.emails[language].additionalTasksEmail.message : null,
                },
              };
              this.healthAndSaftyPolicyFormsEmails[language] = {
                tasksEmail: {
                  subject: settings.healthAndSaftyPolicy ? settings.healthAndSaftyPolicy.emails ? settings.healthAndSaftyPolicy.emails[language].tasksEmail.subject : null : null,
                  message: settings.healthAndSaftyPolicy ? settings.healthAndSaftyPolicy.emails ? settings.healthAndSaftyPolicy.emails[language].tasksEmail.subject : null : null,
                },
                taskReminderEmail: {
                  subject: settings.healthAndSaftyPolicy ? settings.healthAndSaftyPolicy.emails ? settings.healthAndSaftyPolicy.emails[language].taskReminderEmail.subject : null : null,
                  message: settings.healthAndSaftyPolicy ? settings.healthAndSaftyPolicy.emails ? settings.healthAndSaftyPolicy.emails[language].taskReminderEmail.subject : null : null,
                },
                taskCompletionEmail: {
                  subject: settings.healthAndSaftyPolicy ? settings.healthAndSaftyPolicy.emails ? settings.healthAndSaftyPolicy.emails[language].taskCompletionEmail.subject : null : null,
                  message: settings.healthAndSaftyPolicy ? settings.healthAndSaftyPolicy.emails ? settings.healthAndSaftyPolicy.emails[language].taskCompletionEmail.subject : null : null,
                },
                renewTasksEmail: {
                  subject: settings.healthAndSaftyPolicy ? settings.healthAndSaftyPolicy.emails ? settings.healthAndSaftyPolicy.emails[language].renewTasksEmail.subject : null : null,
                  message: settings.healthAndSaftyPolicy ? settings.healthAndSaftyPolicy.emails ? settings.healthAndSaftyPolicy.emails[language].renewTasksEmail.subject : null : null,
                },
                additionalTasksEmail: {
                  subject: settings.policyForms.emails[language].additionalTasksEmail ? settings.policyForms.emails[language].additionalTasksEmail.subject : null,
                  message: settings.policyForms.emails[language].additionalTasksEmail ? settings.policyForms.emails[language].additionalTasksEmail.message : null,
                },
              };
              this.healthAndSaftyTrainingFormsEmails[language] = {
                tasksEmail: {
                  subject: settings.healthAndSaftyTraining ? settings.healthAndSaftyTraining.emails ? settings.healthAndSaftyTraining.emails[language].tasksEmail.subject : null : null,
                  message: settings.healthAndSaftyTraining ? settings.healthAndSaftyTraining.emails ? settings.healthAndSaftyTraining.emails[language].tasksEmail.subject : null : null,
                },
                taskReminderEmail: {
                  subject: settings.healthAndSaftyTraining ? settings.healthAndSaftyTraining.emails ? settings.healthAndSaftyTraining.emails[language].taskReminderEmail.subject : null : null,
                  message: settings.healthAndSaftyTraining ? settings.healthAndSaftyTraining.emails ? settings.healthAndSaftyTraining.emails[language].taskReminderEmail.subject : null : null,
                },
                taskCompletionEmail: {
                  subject: settings.healthAndSaftyTraining ? settings.healthAndSaftyTraining.emails ? settings.healthAndSaftyTraining.emails[language].taskCompletionEmail.subject : null : null,
                  message: settings.healthAndSaftyTraining ? settings.healthAndSaftyTraining.emails ? settings.healthAndSaftyTraining.emails[language].taskCompletionEmail.subject : null : null,
                },
                renewTasksEmail: {
                  subject: settings.healthAndSaftyTraining ? settings.healthAndSaftyTraining.emails ? settings.healthAndSaftyTraining.emails[language].renewTasksEmail.subject : null : null,
                  message: settings.healthAndSaftyTraining ? settings.healthAndSaftyTraining.emails ? settings.healthAndSaftyTraining.emails[language].renewTasksEmail.subject : null : null,
                },
                additionalTasksEmail: {
                  subject: settings.policyForms.emails[language].additionalTasksEmail ? settings.policyForms.emails[language].additionalTasksEmail.subject : null,
                  message: settings.policyForms.emails[language].additionalTasksEmail ? settings.policyForms.emails[language].additionalTasksEmail.message : null,
                },
              };
              // settings.policyForms.emails = this.policyEmails;
              // settings.trainingForms.emails = this.trainingEmails;
              // settings.certificationForms.emails = this.certificationFormsEmails;
              // settings.emails = this.setupEmails;
            } else {
              this.policyEmails[language] = {
                tasksEmail: {
                  subject: null,
                  message: null,
                },
                taskReminderEmail: {
                  subject: null,
                  message: null,
                },
                taskCompletionEmail: {
                  subject: null,
                  message: null,
                },
                renewTasksEmail: {
                  subject: null,
                  message: null,
                },
                additionalTasksEmail: {
                  subject: null,
                  message: null,
                },
              };
              this.trainingEmails[language] = {
                tasksEmail: {
                  subject: null,
                  message: null,
                },
                taskReminderEmail: {
                  subject: null,
                  message: null,
                },
                taskCompletionEmail: {
                  subject: null,
                  message: null,
                },
                renewTasksEmail: {
                  subject: null,
                  message: null,
                },
                additionalTasksEmail: {
                  subject: null,
                  message: null,
                },
              };
              this.certificationFormsEmails[language] = {
                tasksEmail: {
                  subject: null,
                  message: null,
                },
                taskReminderEmail: {
                  subject: null,
                  message: null,
                },
                taskCompletionEmail: {
                  subject: null,
                  message: null,
                },
                renewTasksEmail: {
                  subject: null,
                  message: null,
                },
                tasksBreachEmail: {
                  subject: null,
                  message: null,
                },
                additionalTasksEmail: {
                  subject: null,
                  message: null,
                },
              };
              this.setupEmails[language] = {
                welcomeEmail: {
                  subject: null,
                  message: null,
                },
                additionalTasksEmail: {
                  subject: null,
                  message: null,
                },
              };
              this.healthAndSaftyPolicyFormsEmails[language] = {
                tasksEmail: {
                  subject: null,
                  message: null,
                },
                taskReminderEmail: {
                  subject: null,
                  message: null,
                },
                taskCompletionEmail: {
                  subject: null,
                  message: null,
                },
                renewTasksEmail: {
                  subject: null,
                  message: null,
                },
                additionalTasksEmail: {
                  subject: null,
                  message: null,
                },
              };
              this.healthAndSaftyTrainingFormsEmails[language] = {
                tasksEmail: {
                  subject: null,
                  message: null,
                },
                taskReminderEmail: {
                  subject: null,
                  message: null,
                },
                taskCompletionEmail: {
                  subject: null,
                  message: null,
                },
                renewTasksEmail: {
                  subject: null,
                  message: null,
                },
                additionalTasksEmail: {
                  subject: null,
                  message: null,
                },
              };
              settings.policyForms.emails = this.policyEmails;
              settings.trainingForms.emails = this.trainingEmails;
              settings.certificationForms.emails = this.certificationFormsEmails;
              settings.emails = this.setupEmails;
              settings.healthAndSaftyPolicy.emails = this.healthAndSaftyPolicyFormsEmails;
              settings.healthAndSaftyTraining.emails = this.healthAndSaftyTrainingFormsEmails;
            }
          } );
        }
      } );
    },
    setEmailLanguages () {
      // in this we check that every object got emails object as per selected language if somehow emails object is null then we asign object in this function when that type tab open
      this.configrationSettings.map( settings => {
        if ( settings.emails == null ) {
          this.selectedLanguageLength = this.selectedLanguage.length;
          this.selectedLanguage.map( ( languages ) => {
            let language = languages.value;
            this.formsEmails[language] = {
              tasksEmail: {
                subject: null,
                message: null,
              },
              taskReminderEmail: {
                subject: null,
                message: null,
              },
              taskCompletionEmail: {
                subject: null,
                message: null,
              },
              renewTasksEmail: {
                subject: null,
                message: null,
              },
              additionalTasksEmail: {
                subject: null,
                message: null,
              },
            };
            this.certificationFormsEmails[language] = {
              tasksEmail: {
                subject: null,
                message: null,
              },
              taskReminderEmail: {
                subject: null,
                message: null,
              },
              taskCompletionEmail: {
                subject: null,
                message: null,
              },
              renewTasksEmail: {
                subject: null,
                message: null,
              },
              tasksBreachEmail: {
                subject: null,
                message: null,
              },
              additionalTasksEmail: {
                subject: null,
                message: null,
              },
            };
            this.setupEmails[language] = {
              welcomeEmail: {
                subject: null,
                message: null,
              },
              additionalTasksEmail: {
                subject: null,
                message: null,
              },
            };
            this.healthAndSaftyPolicyFormsEmails[language] = {
              tasksEmail: {
                subject: null,
                message: null,
              },
              taskReminderEmail: {
                subject: null,
                message: null,
              },
              taskCompletionEmail: {
                subject: null,
                message: null,
              },
              renewTasksEmail: {
                subject: null,
                message: null,
              },
              additionalTasksEmail: {
                subject: null,
                message: null,
              },
            };
            this.healthAndSaftyTrainingFormsEmails[language] = {
              tasksEmail: {
                subject: null,
                message: null,
              },
              taskReminderEmail: {
                subject: null,
                message: null,
              },
              taskCompletionEmail: {
                subject: null,
                message: null,
              },
              renewTasksEmail: {
                subject: null,
                message: null,
              },
              additionalTasksEmail: {
                subject: null,
                message: null,
              },
            };
            settings.policyForms.emails = this.formsEmails;
            settings.trainingForms.emails = this.formsEmails;
            settings.certificationForms.emails = this.certificationFormsEmails;
            settings.emails = this.setupEmails;
            settings.healthAndSaftyPolicy.emails = this.healthAndSaftyPolicyFormsEmails;
            settings.healthAndSaftyTraining.emails = this.healthAndSaftyTrainingFormsEmails;
          } );
        }
      } );
    },
    setEmailLanguagesOnModalOpen () {
      // this function is created to create new email object like if in future we need to add one more email type then we have to check hasOwnProperty condtion so if we add new object then on edit or duplication our application don't stuck.

      // first in hasOwnProperty we check that that type email exist if yes then nothing else we asign that email type object in emails language object
      this.policyEmails = {};
      this.trainingEmails = {};
      this.certificationFormsEmails = {};
      this.healthAndSaftyPolicyFormsEmails = {};
      this.healthAndSaftyTrainingFormsEmails = {};
      this.setupEmails = {};
      this.configrationSettings.map( settings => {
        this.selectedLanguageLength = this.selectedLanguage.length;
        this.selectedLanguage.map( ( languages ) => {
          let language = languages.value;
          if ( settings.policyForms.emails == null ) {
            this.policyEmails[language] = {
              tasksEmail: {
                subject: null,
                message: null,
              },
              taskReminderEmail: {
                subject: null,
                message: null,
              },
              taskCompletionEmail: {
                subject: null,
                message: null,
              },
              renewTasksEmail: {
                subject: null,
                message: null,
              },
              additionalTasksEmail: {
                subject: null,
                message: null,
              },
            };
            settings.policyForms.emails = this.policyEmails;
          } else {
            if ( settings.policyForms.emails.hasOwnProperty( language ) ) {
            } else {
              this.policyEmails[language] = {
                tasksEmail: {
                  subject: null,
                  message: null,
                },
                taskReminderEmail: {
                  subject: null,
                  message: null,
                },
                taskCompletionEmail: {
                  subject: null,
                  message: null,
                },
                renewTasksEmail: {
                  subject: null,
                  message: null,
                },
                additionalTasksEmail: {
                  subject: null,
                  message: null,
                },
              };
              settings.policyForms.emails = this.policyEmails;
            }
          }

          if ( settings.trainingForms.emails == null ) {
            this.trainingEmails[language] = {
              tasksEmail: {
                subject: null,
                message: null,
              },
              taskReminderEmail: {
                subject: null,
                message: null,
              },
              taskCompletionEmail: {
                subject: null,
                message: null,
              },
              renewTasksEmail: {
                subject: null,
                message: null,
              },
              additionalTasksEmail: {
                subject: null,
                message: null,
              },
            };
            settings.trainingForms.emails = this.trainingEmails;
          } else {
            if ( settings.trainingForms.emails.hasOwnProperty( language ) ) {
            } else {
              this.trainingEmails[language] = {
                tasksEmail: {
                  subject: null,
                  message: null,
                },
                taskReminderEmail: {
                  subject: null,
                  message: null,
                },
                taskCompletionEmail: {
                  subject: null,
                  message: null,
                },
                renewTasksEmail: {
                  subject: null,
                  message: null,
                },
                additionalTasksEmail: {
                  subject: null,
                  message: null,
                },
              };
              settings.trainingForms.emails = this.trainingEmails;
            }
          }
          if ( settings.certificationForms.emails == null ) {
            this.certificationFormsEmails[language] = {
              tasksEmail: {
                subject: null,
                message: null,
              },
              taskReminderEmail: {
                subject: null,
                message: null,
              },
              taskCompletionEmail: {
                subject: null,
                message: null,
              },
              renewTasksEmail: {
                subject: null,
                message: null,
              },
              tasksBreachEmail: {
                subject: null,
                message: null,
              },
              additionalTasksEmail: {
                subject: null,
                message: null,
              },
            };
            settings.certificationForms.emails = this.certificationFormsEmails;
          } else {
            if ( settings.certificationForms.emails.hasOwnProperty( language ) ) {
            } else {
              this.certificationFormsEmails[language] = {
                tasksEmail: {
                  subject: null,
                  message: null,
                },
                taskReminderEmail: {
                  subject: null,
                  message: null,
                },
                taskCompletionEmail: {
                  subject: null,
                  message: null,
                },
                renewTasksEmail: {
                  subject: null,
                  message: null,
                },
                tasksBreachEmail: {
                  subject: null,
                  message: null,
                },
                additionalTasksEmail: {
                  subject: null,
                  message: null,
                },
              };
              settings.certificationForms.emails = this.certificationFormsEmails;
            }
          }
          if ( settings.healthAndSaftyPolicy.emails == null ) {
            this.healthAndSaftyPolicyFormsEmails[language] = {
              tasksEmail: {
                subject: null,
                message: null,
              },
              taskReminderEmail: {
                subject: null,
                message: null,
              },
              taskCompletionEmail: {
                subject: null,
                message: null,
              },
              renewTasksEmail: {
                subject: null,
                message: null,
              },
              additionalTasksEmail: {
                subject: null,
                message: null,
              },
            };
            settings.healthAndSaftyPolicy.emails = this.healthAndSaftyPolicyFormsEmails;
          } else {
            if ( settings.healthAndSaftyPolicy.emails.hasOwnProperty( language ) ) {
            } else {
              this.healthAndSaftyPolicyFormsEmails[language] = {
                tasksEmail: {
                  subject: null,
                  message: null,
                },
                taskReminderEmail: {
                  subject: null,
                  message: null,
                },
                taskCompletionEmail: {
                  subject: null,
                  message: null,
                },
                renewTasksEmail: {
                  subject: null,
                  message: null,
                },
                additionalTasksEmail: {
                  subject: null,
                  message: null,
                },
              };
              settings.healthAndSaftyPolicy.emails = this.healthAndSaftyPolicyFormsEmails;
            }
          }
          if ( settings.healthAndSaftyTraining.emails == null ) {
            this.healthAndSaftyTrainingFormsEmails[language] = {
              tasksEmail: {
                subject: null,
                message: null,
              },
              taskReminderEmail: {
                subject: null,
                message: null,
              },
              taskCompletionEmail: {
                subject: null,
                message: null,
              },
              renewTasksEmail: {
                subject: null,
                message: null,
              },
              additionalTasksEmail: {
                subject: null,
                message: null,
              },
            };
            settings.healthAndSaftyTraining.emails = this.healthAndSaftyTrainingFormsEmails;
          } else {
            if ( settings.healthAndSaftyTraining.emails.hasOwnProperty( language ) ) {
            } else {
              this.healthAndSaftyTrainingFormsEmails[language] = {
                tasksEmail: {
                  subject: null,
                  message: null,
                },
                taskReminderEmail: {
                  subject: null,
                  message: null,
                },
                taskCompletionEmail: {
                  subject: null,
                  message: null,
                },
                renewTasksEmail: {
                  subject: null,
                  message: null,
                },
                additionalTasksEmail: {
                  subject: null,
                  message: null,
                },
              };
              settings.healthAndSaftyTraining.emails = this.healthAndSaftyTrainingFormsEmails;
            }
          }
          if ( settings.emails == null ) {
            this.setupEmails[language] = {
              welcomeEmail: {
                subject: null,
                message: null,
              },
            };
            settings.emails = this.setupEmails;
          } else {
            if ( settings.emails.hasOwnProperty( language ) ) {
            } else {
              this.setupEmails[language] = {
                welcomeEmail: {
                  subject: null,
                  message: null,
                },
              };
              settings.emails = this.setupEmails;
            }
          }
        } );
      } );
      this.setNewEmailObject();
    },
    setNewEmailObject () {
      this.selectedLanguage.map( ( languages ) => {
        let languageValue = languages.value;
        this.configrationSettings.map( ( settings, settingsIndex ) => {
          this.checkPolicyFormsEmails( settings, languageValue, settingsIndex );
          this.checkTrainingFormsEmails( settings, languageValue, settingsIndex );
          this.checkCertificationFormsEmails( settings, languageValue, settingsIndex );
          this.checkHealthAndSaftyPolicyEmails( settings, languageValue, settingsIndex );
          this.checkHealthAndSaftyTrainingEmails( settings, languageValue, settingsIndex );
          this.checkRootEmails( settings, languageValue, settingsIndex );
        } );
      } );
    },
    checkRootEmails ( settings, languageValue, settingsIndex ) {
      if ( this.configrationSettings[settingsIndex].emails[languageValue].hasOwnProperty( "welcomeEmail" ) ) {
      } else {
        let welcomeEmail = {
          subject: null,
          message: null,
        };
        Object.assign( this.configrationSettings[settingsIndex].emails[languageValue], { welcomeEmail } );
      }
      if ( this.configrationSettings[settingsIndex].emails[languageValue].hasOwnProperty( "additionalTasksEmail" ) ) {
      } else {
        let additionalTasksEmail = {
          subject: null,
          message: null,
        };
        Object.assign( this.configrationSettings[settingsIndex].emails[languageValue], { additionalTasksEmail } );
      }
    },
    checkPolicyFormsEmails ( settings, languageValue, settingsIndex ) {
      if ( this.configrationSettings[settingsIndex].policyForms.emails[languageValue].hasOwnProperty( "tasksEmail" ) ) {
      } else {
        let tasksEmail = {
          subject: null,
          message: null,
        };
        Object.assign( this.configrationSettings[settingsIndex].policyForms.emails[languageValue], { tasksEmail } );
      }
      if ( this.configrationSettings[settingsIndex].policyForms.emails[languageValue].hasOwnProperty( "taskReminderEmail" ) ) {
      } else {
        let taskReminderEmail = {
          subject: null,
          message: null,
        };
        Object.assign( this.configrationSettings[settingsIndex].policyForms.emails[languageValue], { taskReminderEmail } );
      }
      if ( this.configrationSettings[settingsIndex].policyForms.emails[languageValue].hasOwnProperty( "taskCompletionEmail" ) ) {
      } else {
        let taskCompletionEmail = {
          subject: null,
          message: null,
        };
        Object.assign( this.configrationSettings[settingsIndex].policyForms.emails[languageValue], { taskCompletionEmail } );
      }
      if ( this.configrationSettings[settingsIndex].policyForms.emails[languageValue].hasOwnProperty( "renewTasksEmail" ) ) {
      } else {
        let renewTasksEmail = {
          subject: null,
          message: null,
        };
        Object.assign( this.configrationSettings[settingsIndex].policyForms.emails[languageValue], { renewTasksEmail } );
      }
      if ( this.configrationSettings[settingsIndex].policyForms.emails[languageValue].hasOwnProperty( "additionalTasksEmail" ) ) {
      } else {
        let additionalTasksEmail = {
          subject: null,
          message: null,
        };
        Object.assign( this.configrationSettings[settingsIndex].policyForms.emails[languageValue], { additionalTasksEmail } );
      }
    },
    checkTrainingFormsEmails ( settings, languageValue, settingsIndex ) {
      if ( this.configrationSettings[settingsIndex].trainingForms.emails[languageValue].hasOwnProperty( "tasksEmail" ) ) {
      } else {
        let tasksEmail = {
          subject: null,
          message: null,
        };
        Object.assign( this.configrationSettings[settingsIndex].trainingForms.emails[languageValue], { tasksEmail } );
      }
      if ( this.configrationSettings[settingsIndex].trainingForms.emails[languageValue].hasOwnProperty( "taskReminderEmail" ) ) {
      } else {
        let taskReminderEmail = {
          subject: null,
          message: null,
        };
        Object.assign( this.configrationSettings[settingsIndex].trainingForms.emails[languageValue], { taskReminderEmail } );
      }
      if ( this.configrationSettings[settingsIndex].trainingForms.emails[languageValue].hasOwnProperty( "taskCompletionEmail" ) ) {
      } else {
        let taskCompletionEmail = {
          subject: null,
          message: null,
        };
        Object.assign( this.configrationSettings[settingsIndex].trainingForms.emails[languageValue], { taskCompletionEmail } );
      }
      if ( this.configrationSettings[settingsIndex].trainingForms.emails[languageValue].hasOwnProperty( "renewTasksEmail" ) ) {
      } else {
        let renewTasksEmail = {
          subject: null,
          message: null,
        };
        Object.assign( this.configrationSettings[settingsIndex].trainingForms.emails[languageValue], { renewTasksEmail } );
      }
      if ( this.configrationSettings[settingsIndex].trainingForms.emails[languageValue].hasOwnProperty( "additionalTasksEmail" ) ) {
      } else {
        let additionalTasksEmail = {
          subject: null,
          message: null,
        };
        Object.assign( this.configrationSettings[settingsIndex].trainingForms.emails[languageValue], { additionalTasksEmail } );
      }
    },
    checkCertificationFormsEmails ( settings, languageValue, settingsIndex ) {
      if ( this.configrationSettings[settingsIndex].certificationForms.emails[languageValue].hasOwnProperty( "tasksEmail" ) ) {
      } else {
        let tasksEmail = {
          subject: null,
          message: null,
        };
        Object.assign( this.configrationSettings[settingsIndex].certificationForms.emails[languageValue], { tasksEmail } );
      }
      if ( this.configrationSettings[settingsIndex].certificationForms.emails[languageValue].hasOwnProperty( "taskReminderEmail" ) ) {
      } else {
        let taskReminderEmail = {
          subject: null,
          message: null,
        };
        Object.assign( this.configrationSettings[settingsIndex].certificationForms.emails[languageValue], { taskReminderEmail } );
      }
      if ( this.configrationSettings[settingsIndex].certificationForms.emails[languageValue].hasOwnProperty( "taskCompletionEmail" ) ) {
      } else {
        let taskCompletionEmail = {
          subject: null,
          message: null,
        };
        Object.assign( this.configrationSettings[settingsIndex].certificationForms.emails[languageValue], { taskCompletionEmail } );
      }
      if ( this.configrationSettings[settingsIndex].certificationForms.emails[languageValue].hasOwnProperty( "renewTasksEmail" ) ) {
      } else {
        let renewTasksEmail = {
          subject: null,
          message: null,
        };
        Object.assign( this.configrationSettings[settingsIndex].certificationForms.emails[languageValue], { renewTasksEmail } );
      }
      if ( this.configrationSettings[settingsIndex].certificationForms.emails[languageValue].hasOwnProperty( "tasksBreachEmail" ) ) {
      } else {
        let tasksBreachEmail = {
          subject: null,
          message: null,
        };
        Object.assign( this.configrationSettings[settingsIndex].certificationForms.emails[languageValue], { tasksBreachEmail } );
      }
      if ( this.configrationSettings[settingsIndex].certificationForms.emails[languageValue].hasOwnProperty( "additionalTasksEmail" ) ) {
      } else {
        let additionalTasksEmail = {
          subject: null,
          message: null,
        };
        Object.assign( this.configrationSettings[settingsIndex].certificationForms.emails[languageValue], { additionalTasksEmail } );
      }
    },
    checkHealthAndSaftyPolicyEmails ( settings, languageValue, settingsIndex ) {
      if ( this.configrationSettings[settingsIndex].healthAndSaftyPolicy.emails[languageValue].hasOwnProperty( "tasksEmail" ) ) {
      } else {
        let tasksEmail = {
          subject: null,
          message: null,
        };
        Object.assign( this.configrationSettings[settingsIndex].healthAndSaftyPolicy.emails[languageValue], { tasksEmail } );
      }
      if ( this.configrationSettings[settingsIndex].healthAndSaftyPolicy.emails[languageValue].hasOwnProperty( "taskReminderEmail" ) ) {
      } else {
        let taskReminderEmail = {
          subject: null,
          message: null,
        };
        Object.assign( this.configrationSettings[settingsIndex].healthAndSaftyPolicy.emails[languageValue], { taskReminderEmail } );
      }
      if ( this.configrationSettings[settingsIndex].healthAndSaftyPolicy.emails[languageValue].hasOwnProperty( "taskCompletionEmail" ) ) {
      } else {
        let taskCompletionEmail = {
          subject: null,
          message: null,
        };
        Object.assign( this.configrationSettings[settingsIndex].healthAndSaftyPolicy.emails[languageValue], { taskCompletionEmail } );
      }
      if ( this.configrationSettings[settingsIndex].healthAndSaftyPolicy.emails[languageValue].hasOwnProperty( "renewTasksEmail" ) ) {
      } else {
        let renewTasksEmail = {
          subject: null,
          message: null,
        };
        Object.assign( this.configrationSettings[settingsIndex].healthAndSaftyPolicy.emails[languageValue], { renewTasksEmail } );
      }
      if ( this.configrationSettings[settingsIndex].healthAndSaftyPolicy.emails[languageValue].hasOwnProperty( "additionalTasksEmail" ) ) {
      } else {
        let additionalTasksEmail = {
          subject: null,
          message: null,
        };
        Object.assign( this.configrationSettings[settingsIndex].healthAndSaftyPolicy.emails[languageValue], { additionalTasksEmail } );
      }
    },
    checkHealthAndSaftyTrainingEmails ( settings, languageValue, settingsIndex ) {
      if ( this.configrationSettings[settingsIndex].healthAndSaftyTraining.emails[languageValue].hasOwnProperty( "tasksEmail" ) ) {
      } else {
        let tasksEmail = {
          subject: null,
          message: null,
        };
        Object.assign( this.configrationSettings[settingsIndex].healthAndSaftyTraining.emails[languageValue], { tasksEmail } );
      }
      if ( this.configrationSettings[settingsIndex].healthAndSaftyTraining.emails[languageValue].hasOwnProperty( "taskReminderEmail" ) ) {
      } else {
        let taskReminderEmail = {
          subject: null,
          message: null,
        };
        Object.assign( this.configrationSettings[settingsIndex].healthAndSaftyTraining.emails[languageValue], { taskReminderEmail } );
      }
      if ( this.configrationSettings[settingsIndex].healthAndSaftyTraining.emails[languageValue].hasOwnProperty( "taskCompletionEmail" ) ) {
      } else {
        let taskCompletionEmail = {
          subject: null,
          message: null,
        };
        Object.assign( this.configrationSettings[settingsIndex].healthAndSaftyTraining.emails[languageValue], { taskCompletionEmail } );
      }
      if ( this.configrationSettings[settingsIndex].healthAndSaftyTraining.emails[languageValue].hasOwnProperty( "renewTasksEmail" ) ) {
      } else {
        let renewTasksEmail = {
          subject: null,
          message: null,
        };
        Object.assign( this.configrationSettings[settingsIndex].healthAndSaftyTraining.emails[languageValue], { renewTasksEmail } );
      }
      if ( this.configrationSettings[settingsIndex].healthAndSaftyTraining.emails[languageValue].hasOwnProperty( "additionalTasksEmail" ) ) {
      } else {
        let additionalTasksEmail = {
          subject: null,
          message: null,
        };
        Object.assign( this.configrationSettings[settingsIndex].healthAndSaftyTraining.emails[languageValue], { additionalTasksEmail } );
      }
    },
    showDuplicateWorkflowModal ( value ) {
      this.configrationSettings = [];
      this.selectedLanguage = [];
      this.selectedLanguageLength = null;
      this.isDuplicateWorkFlow = true;
      this.workflowSettingId = value.id;
      this.form = {
        title: value.title,
        version: value.version,
      };
      let configurationData = JSON.parse( value.configuration );
      if (
        configurationData.languages &&
        configurationData.languages.length > 0
      ) {
        this.selectedLanguageLength = configurationData.languages.length;
        configurationData.languages.map( ( types ) => {
          this.selectedLanguage.push( types );
        } );
      }
      if ( configurationData.settings.length > 0 ) {
        configurationData.settings.map( setting => {
          if ( setting.healthAndSaftyPolicy == undefined || !setting.hasOwnProperty( "healthAndSaftyPolicy" ) ) {
            let healthAndSaftyPolicy = {
              forms: [],
              emails: null
            };
            Object.assign( setting, { healthAndSaftyPolicy } );
          }
          if ( setting.healthAndSaftyTraining == undefined || !setting.hasOwnProperty( "healthAndSaftyTraining" ) ) {
            let healthAndSaftyTraining = {
              forms: [],
              emails: null
            };
            Object.assign( setting, { healthAndSaftyTraining } );
          }
        } );
        this.configrationSettings = configurationData.settings;
        this.setEmailLanguagesOnModalOpen();
      }
      this.showAddModal = true;
    },
    showEditWorkflowModal ( value ) {
      this.selectedLanguage = [];
      this.selectedLanguageLength = null;
      this.configrationSettings = [];
      this.isEditWorkFlow = true;
      this.workflowSettingId = value.id;
      this.form = {
        title: value.title,
        version: value.version,
      };
      let configurationData = JSON.parse( value.configuration );
      if (
        configurationData.languages &&
        configurationData.languages.length > 0
      ) {
        this.selectedLanguageLength = configurationData.languages.length;
        configurationData.languages.map( ( types ) => {
          this.selectedLanguage.push( types );
        } );
      }
      if ( configurationData.settings.length > 0 ) {
        configurationData.settings.map( setting => {
          if ( setting.healthAndSaftyPolicy == undefined || !setting.hasOwnProperty( "healthAndSaftyPolicy" ) ) {
            let healthAndSaftyPolicy = {
              forms: [],
              emails: null
            };
            Object.assign( setting, { healthAndSaftyPolicy } );
          }
          if ( setting.healthAndSaftyTraining == undefined || !setting.hasOwnProperty( "healthAndSaftyTraining" ) ) {
            let healthAndSaftyTraining = {
              forms: [],
              emails: null
            };
            Object.assign( setting, { healthAndSaftyTraining } );
          }
        } );
        this.configrationSettings = configurationData.settings;
        this.setEmailLanguagesOnModalOpen();
      }
      this.showAddModal = true;
    },
    showAddNewEmployeeModal () {
      this.showAddModal = true;
    },
    reloadTable () {
      this.$root.$emit( "bv::refresh::table", "employee-table" );
    },
    formatDate ( value ) {
      if ( value ) {
        moment.locale( "en" );
        return moment( String( value ) ).format( "DD/MM/YYYY" );
      }
    },
    setTitleValue ( value ) {
      if ( value ) {
        return "";
      } else if ( value == null ) {
        this.selectedLanguage = [{ text: "English", value: "1" }];
        this.configrationSettings = [
          {
            title: null,
            startDate: null,
            endDateValue: null,
            certificationAndTrainingDate: null,
            configration: {
              emailTags: this.emailTagsOptions,
              platformSettings: this.platformSettingOptions
            },
            policyForms: {
              forms: [],
              emails: null,
            },
            trainingForms: {
              forms: [],
              emails: null,
            },
            certificationForms: {
              forms: [],
              emails: null,
            },
            emails: null,
            healthAndSaftyPolicy: {
              forms: [],
              emails: null,
            },
            healthAndSaftyTraining: {
              forms: [],
              emails: null,
            },
          },
        ];
      }
    },
    closeModal () {
      this.showAddModal = false;
      this.form = {
        title: null,
        version: null,
      };
      this.isEditWorkFlow = false;
      this.isDuplicateWorkFlow = false;
      this.workflowSettingId = null;
      this.selectedLanguage = [{ text: "English", value: "1" }];
      this.configrationSettings = [
        {
          title: null,
          startDate: null,
          endDateValue: null,
          certificationAndTrainingDate: null,
          configration: {
            emailTags: this.emailTagsOptions,
            platformSettings: this.platformSettingOptions,
          },
          policyForms: {
            forms: [],
            emails: null,
          },
          trainingForms: {
            forms: [],
            emails: null,
          },
          certificationForms: {
            forms: [],
            emails: null,
          },
          emails: null,
          healthAndSaftyPolicy: {
            forms: [],
            emails: null,
          },
          healthAndSaftyTraining: {
            forms: [],
            emails: null,
          },
        },
      ];
      this.$v.$reset();
      this.submiting = false;
      this.isLoading = false;
      this.responseSuccess = false;
    },
    async getEmailTagsList () {
      this.emailTagsOptions = [];
      this.isLoading = true;
      try {
        let result = await HTTP( "get", "api/v1/tag/list", null );
        this.configrationSettings[0].configration.emailTags = result.data.emailTags;
        this.emailTagsOptions = result.data.emailTags;
        this.isLoading = false;
      } catch ( error ) {
        this.isLoading = false;
      }
    },
    async getPlatformSettingList () {
      this.platformSettingOptions = [];
      this.isLoading = true;
      try {
        let result = await HTTP( "get", "api/v1/platform/list", null );
        if ( result.data[0].platform_variables ) {
          let settings = JSON.parse( result.data[0].platform_variables );
          this.configrationSettings[0].configration.platformSettings = settings;
          this.platformSettingOptions = settings;
        }
        this.isLoading = false;
      } catch ( error ) {
        this.isLoading = false;
      }
    },
    async getEmployeeLanguages () {
      this.languagesOptions = [];
      this.isLoading = true;
      try {
        let result = await HTTP( "get", "api/v1/constants/languages-list", null );
        this.languagesOptions = result.data.employeeLanuages;
        this.isLoading = false;
      } catch ( error ) {
        this.isLoading = false;
      }
    },
    async getFormsOptions () {
      this.healthAndSaftyPolicyFormsOptions = [];
      this.healthAndSaftyTrainingFormsOptions = [];
      this.policyFormsOptions = [];
      this.trainingFormsOptions = [];
      this.certificationFormsOptions = [];
      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem( "accessToken" );
      try {
        let result = await HTTP(
          "get",
          "api/v1/onboarding/forms/all-onboarding-forms-list",
          null,
          {
            Authorization: token,
          }
        );
        if ( result.status == 200 && result.data.onboardingForms ) {
          result.data.onboardingForms.map( ( forms ) => {
            if ( forms.onboarding_form_type_id == 2 ) {
              let relatedFormIds =
                forms.related_form_ids == null
                  ? []
                  : JSON.parse( forms.related_form_ids );
              this.policyFormsOptions.push( {
                text: forms.text,
                value: forms.value,
                reletedFormIds: relatedFormIds,
              } );
            } else if ( forms.onboarding_form_type_id == 3 ) {
              let relatedFormIds =
                forms.related_form_ids == null
                  ? []
                  : JSON.parse( forms.related_form_ids );
              this.trainingFormsOptions.push( {
                text: forms.text,
                value: forms.value,
                reletedFormIds: relatedFormIds,
              } );
            } else if ( forms.onboarding_form_type_id == 4 ) {
              let relatedFormIds =
                forms.related_form_ids == null
                  ? []
                  : JSON.parse( forms.related_form_ids );
              this.certificationFormsOptions.push( {
                text: forms.text,
                value: forms.value,
                reletedFormIds: relatedFormIds,
              } );
            } else if ( forms.onboarding_form_type_id == 7 ) {
              let relatedFormIds =
                forms.related_form_ids == null
                  ? []
                  : JSON.parse( forms.related_form_ids );
              this.healthAndSaftyPolicyFormsOptions.push( {
                text: forms.text,
                value: forms.value,
                reletedFormIds: relatedFormIds,
              } );
            } else if ( forms.onboarding_form_type_id == 8 ) {
              let relatedFormIds =
                forms.related_form_ids == null
                  ? []
                  : JSON.parse( forms.related_form_ids );
              this.healthAndSaftyTrainingFormsOptions.push( {
                text: forms.text,
                value: forms.value,
                reletedFormIds: relatedFormIds,
              } );
            }
          } );
        }
        this.isLoading = false;
      } catch ( error ) {
        this.isLoading = false;
      }
    },
    setTitleIndex ( value, cloenFieldsIndex ) {
      if ( value ) {
        this.configurationTitleIndex = cloenFieldsIndex;
        this.invalidTitleValue = null;
      } else {
        this.configurationTitleIndex = null;
      }
    },
    setStartDateIndex ( value, cloenFieldsIndex ) {
      if ( value ) {
        this.configurationStartDateIndex = cloenFieldsIndex;
        this.invalidStartDateValue = null;
      } else {
        this.configurationStartDateIndex = null;
      }
    },
    setCertificationAndTrainingDateIndex ( value, cloenFieldsIndex ) {
      if ( value ) {
        this.configurationCertificationAndTrainingDateIndex = cloenFieldsIndex;
        this.invalidCertificationAndTrainingDateValue = null;
      } else {
        this.configurationCertificationAndTrainingDateIndex = null;
      }
    },
    setEndDateIndex ( value, cloenFieldsIndex ) {
      if ( value ) {
        this.configurationEndDateIndex = cloenFieldsIndex;
        this.invalidEndDateValue = null;
      } else {
        this.configurationEndDateIndex = null;
      }
    },
    setSettingsLanuages ( cloenFieldsIndex ) {
      if ( this.configrationSettings[cloenFieldsIndex].emails == null ) {
        this.setEmailLanguages( cloenFieldsIndex );
      }
    },
    addRowInTable () {
      if ( this.configurationTitleIndex == null ) {
        this.invalidTitleValue = "Please Enter Title";
        return;
      } else if ( this.configurationStartDateIndex == null ) {
        this.invalidStartDateValue = "Please Select Start Date";
        return;
      } else if ( this.configurationCertificationAndTrainingDateIndex == null ) {
        this.invalidCertificationAndTrainingDateValue = "Please Select Certification & Training Trigger Date";
        return;
      } else if ( this.configurationEndDateIndex == null ) {
        this.invalidEndDateValue = "Please Select End Date";
        return;
      } else {
        this.configrationSettings.push( {
          title: null,
          startDate: null,
          endDateValue: null,
          certificationAndTrainingDate: null,
          configration: {
            emailTags: this.emailTagsOptions,
            platformSettings: this.platformSettingOptions
          },
          policyForms: {
            forms: [],
            emails: null,
          },
          trainingForms: {
            forms: [],
            emails: null,
          },
          certificationForms: {
            forms: [],
            emails: null,
          },
          emails: null,
          healthAndSaftyPolicy: {
            forms: [],
            emails: null,
          },
          healthAndSaftyTraining: {
            forms: [],
            emails: null,
          },
        } );
        this.setEmailLanguages();
      }
      this.configurationTitleIndex = null;
      this.configurationStartDateIndex = null;
      this.configurationEndDateIndex = null;
      this.invalidTitleValue = null;
      this.invalidStartDateValue = null;
      this.invalidEndDateValue = null;
      this.invalidCertificationAndTrainingDateValue = null;
    },
    onDeleteAmountRow ( cloenFieldsIndex ) {
      this.configrationSettings.splice( cloenFieldsIndex, 1 );
    },
    checkValidation () {
      this.$v.form.$touch();
      if ( this.$v.form.$anyError ) {
        return;
      } else if ( this.isEditWorkFlow ) {
        this.updateEmployeeWorkFlowSetting().then( this.reloadTable );
      } else {
        this.saveEmployeeWorkFlowSetting().then( this.reloadTable );
      }
    },
    async updateEmployeeWorkFlowSetting () {
      let formData = {
        user_id: localStorage.getItem( "userId" ),
        workflow_setting_id: this.workflowSettingId,
        title: this.form.title,
        version: this.form.version,
        workflow_type_id: 7,
        configuration: {
          languages: this.selectedLanguage,
          settings: this.configrationSettings,
        },
      };
      try {
        this.submiting = true;
        this.isLoading = true;
        await HTTP( "post", "api/v1/workflow/settings/update", formData );
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
      } catch ( err ) {
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = false;
        return [err];
      }
    },
    async saveEmployeeWorkFlowSetting () {
      let formData = {
        user_id: localStorage.getItem( "userId" ),
        title: this.form.title,
        version: this.form.version,
        workflow_type_id: 7,
        configuration: {
          languages: this.selectedLanguage,
          settings: this.configrationSettings,
        },
      };
      try {
        this.submiting = true;
        this.isLoading = true;
        await HTTP( "post", "api/v1/workflow/settings/create", formData );
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
      } catch ( err ) {
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = false;
        return [err];
      }
    },
  },
};
</script>
<style>
.custom-date-picker {
  width: 100%;
  border: none;
}
.custom-date-picker:focus {
  border: none;
}
.date-calender {
  width: 235px !important;
  background: #dee2e6 !important;
}
.form-control-small-date-picker {
  height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}
.workflow-setting-custom-date-picker {
  width: 100%;
  border: none;
}
.workflow-setting-custom-date-picker:focus {
  border: none;
}
.workflow-setting-date-calender {
  width: 235px !important;
  background: #dee2e6 !important;
}
.employee-languages-tabs-layout {
  width: 50rem;
  transform: translateX(12rem);
}
.employee-email-languages-tabs-layout {
  width: 50rem;
  transform: translateX(9rem);
}
.fit-width {
  max-width: 145px;
  text-align: center;
}
</style>
